<main class="app_template_e__container" id="templateContainer">
  <app-print-header></app-print-header>
  <p-dialog [(visible)]="displayAgentes" [style]="{ width: '600px', height: '300px' }" [modal]="true">
    <ng-template pTemplate="header">
      <label><strong>Esops de exposición: </strong>
        {{ examen.esops?.length }}</label>
    </ng-template>
    <p-scrollPanel [style]="{ height: '200px' }">
      <p-table [value]="examen.esops">
        <ng-template pTemplate="header">
          <tr>
            <th style="width: 20%; text-align: center;">Código</th>
            <th style="width: 80%; text-align: center;">Concepto</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item>
          <tr>
            <td style="text-align: center;">{{ item.codigo }}</td>
            <td style="text-align: center;">{{ item.descripcion }}</td>
          </tr>
        </ng-template>
      </p-table>
    </p-scrollPanel>
    <p-footer>
      <p-button type="button" label="Regresar al examen" (click)="displayAgentes = false"></p-button>
    </p-footer>
  </p-dialog>
  <!-- ------------------------------------------------inicio de formulario------------------------------------------------ -->

  <form (ngSubmit)="onSubmit()" *ngIf="examForm" [formGroup]="examForm" id="idFormLogin" name="formLogin">
    <div class="form-container p-fluid">

      <!-- ------------------------------------------------encabezado------------------------------------------------ -->
      <div class="p-grid p-jc-between" style="margin-bottom: 15px;">
        <div class="" style="display: flex;">
          <span>
            <i (click)="goBack()" class="pi pi-arrow-left"
              style="font-size: 1rem; margin-right: 10px; cursor: pointer;"></i>
          </span>
          <label class="p-title-seccion form-examen-name-title">{{configForm.name}}</label>
        </div>

        <span class="print_hide-on-print">
          <app-print-button></app-print-button>
        </span>
      </div>
      <!-- ------------------------------------------------primer row (fecha)------------------------------------------------ -->
      <div class="p-grid">
        <div *ngIf="configForm.findField('fechaRealizacion')" class="p-field p-col-12 p-md-3">
          <app-fiel-title label="Fecha de realización" required="true"></app-fiel-title>
          <span class="print_edadInputNumber_hide print_show-on-print print_filled_input">
            {{examForm.controls.fechaRealizacion.value | date:"dd/MM/yyyy"}}
          </span>

          <p-calendar formControlName="fechaRealizacion" [showIcon]="true" dataType="date" dateFormat="dd/mm/yy"
            placeholder="dd/mm/yyyy" id="date_init" inputId="range" name="date_init" [maxDate]="maxDate"
            [minDate]="minDate" class="print_hide-on-print"
            [ngClass]="{'ng-invalid ng-dirty': submitted && f.fechaRealizacion.invalid}"
            [disabled]="examen?.modoVista === 'ver'">
          </p-calendar>

          <app-invalid-from-message *ngIf="submitted && f.fechaRealizacion.invalid"></app-invalid-from-message>
        </div>

        <!-- NRO LOTE-->
        <div class="p-field p-col-12 p-md-2">
          <app-fiel-title label="Nro. Lote"></app-fiel-title>
          <p class="readOnly">
            {{examen.lote.numeroLote}}
          </p>
        </div>

        <!-- NRO CARPETA-->
        <div class="p-field p-col-12 p-md-2">
          <app-fiel-title label="Nro. Carpeta"></app-fiel-title>
          <p class="readOnly">
            {{examen.numeroCarpeta}}
          </p>
        </div>

        <div class="p-col-12 p-md-3 print_hide-on-print custom-agentes">
          <label class="color-text" (click)="displayAgentes = true">
            Esops de exposición ({{ examen.esops?.length }})</label>
        </div>
      </div>

      <!-- Seccion Empleador -->
      <div *ngIf="configForm.findSection('Empleador')">
        <div class="p-grid p-mt-2">
          <label class="p-title-seccion">
            {{ configForm.findNumberSection("Empleador") }}.Datos de la empresa
          </label>
        </div>
        <p-divider></p-divider>
        <div class="p-grid flex-end">
          <div class="p-field p-col-12 p-md-4">
            <app-fiel-title label="Razón Social"></app-fiel-title>
            <p class="readOnly">{{ examen.lote.empresa.razonSocial }}</p>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <app-fiel-title label="CUIT"></app-fiel-title>
            <p class="readOnly">{{ examen.lote.empresa.cuit }}</p>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <app-fiel-title label="Establecimiento"></app-fiel-title>
            <p class="readOnly">{{ examen.lote.establecimiento?.nombre }}</p>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <app-fiel-title label="Teléfono"></app-fiel-title>
            <p class="readOnly">{{ examen.lote.establecimiento?.telefono }}</p>
          </div>
          <div class="p-field p-col-12 p-md-4 print_row-full">
            <app-fiel-title label="Dirección de E-mail"></app-fiel-title>
            <p class="readOnly p-field-word-break">{{ examen.lote.establecimiento?.mail }}</p>
          </div>
          <div class="p-field p-col-12 p-md-4 print_row-full">
            <app-fiel-title label="Domicilio"></app-fiel-title>
            <p class="readOnly">{{ examen.lote.establecimiento?.domicilio }}</p>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <app-fiel-title label="Piso"></app-fiel-title>
            <p class="readOnly">{{ examen.lote.establecimiento?.piso }}</p>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <app-fiel-title label="Departamento"></app-fiel-title>
            <p class="readOnly">{{ examen.lote.establecimiento?.depto }}</p>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <app-fiel-title label="Localidad"></app-fiel-title>
            <p class="readOnly">{{ examen.lote.establecimiento?.localidad }}</p>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <app-fiel-title label="Provincia"></app-fiel-title>
            <p class="readOnly">{{ examen.lote.establecimiento?.provincia }}</p>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <app-fiel-title label="CP"></app-fiel-title>
            <p class="readOnly">{{ examen.lote.establecimiento?.codigoPostal }}</p>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <app-fiel-title label="CIIU"></app-fiel-title>
            <p class="readOnly">{{ examen.lote.ciiu }}</p>
          </div>
          <div class="p-field p-col-12 p-md-4 print_row-full">
            <app-fiel-title label="Descripción CIIU"></app-fiel-title>
            <p class="readOnly">{{ examen.lote.descripcionCiiu }}</p>
          </div>
        </div>
        <div *ngIf="configForm.findField('responsableMedico')" class="p-grid p-grid-space">
          <div class="p-col-12 p-md-3">
            <app-fiel-title label="Responsable Médico" required="true"></app-fiel-title>
            <div style="display: flex; flex-direction: row;" [ngClass]="{'ng-invalid ng-dirty': submitted && f.responsableMedico.invalid }">
              <p-radioButton name="responsableMedico" [value]="true" formControlName="responsableMedico"
                label="Si" [ngClass]="{'ng-invalid ng-dirty': submitted && f.responsableMedico.invalid}"
                [disabled]="examen?.modoVista === 'ver'">
              </p-radioButton>
              <p-radioButton name="responsableMedico" [value]="false" formControlName="responsableMedico"
                label="No" [ngClass]="{'ng-invalid ng-dirty': submitted && f.responsableMedico.invalid}"
                [disabled]="examen?.modoVista === 'ver'">
              </p-radioButton>
            </div>
            <app-invalid-from-message *ngIf="submitted && f.responsableMedico.invalid"></app-invalid-from-message>
          </div>
        </div>
      </div>

      <!-- Seccion Trabajador -->
      <div *ngIf="configForm.findSection('Trabajador')">
        <div class="p-grid p-mt-2">
          <span class="p-title-seccion">
            {{ configForm.findNumberSection("Trabajador") }}.Datos Del Trabajador
          </span>
        </div>
        <p-divider></p-divider>
        <div class="p-grid">
          <div class="p-field p-col-12 p-md-4 print_row-full">
            <app-fiel-title label="Apellido y nombre" required="true"></app-fiel-title>
            <input [ngClass]="{'ng-invalid ng-dirty': submitted && f.apellidoNombre.invalid}" alfanumericoDirective
              formControlName="apellidoNombre" id="apellidoNombre" name="apellidoNombre" maxlength="100" pInputText type="text"
              [attr.disabled]="examen?.modoVista === 'ver' || deshabilitarApellidoNombreTrabajador() ? true : null" />
            <span class="print_edadInputNumber_hide print_show-on-print print_filled_input">
              {{examForm.controls.apellidoNombre.value}}
            </span>
            <app-invalid-from-message *ngIf="submitted && f.apellidoNombre.errors?.required"></app-invalid-from-message>
            <app-invalid-from-message *ngIf="submitted && f.apellidoNombre.errors?.apellidoNombreTrabajadorValidator"
								message="{{ f.apellidoNombre.errors?.apellidoNombreTrabajadorValidatorMessage }}">
							</app-invalid-from-message>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <app-fiel-title label="CUIL"></app-fiel-title>
            <p class="readOnly">
              {{examen.trabajador.cuil}}
            </p>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <app-fiel-title label="Fecha de nacimiento" required="true"></app-fiel-title>
            <span class="print_edadInputNumber_hide print_show-on-print print_filled_input">
              {{examForm.controls.fechaNacimiento.value | date: "dd/MM/yyyy"}}
            </span>
            <p-calendar formControlName="fechaNacimiento" [showIcon]="true" dateFormat="dd/mm/yy"
              placeholder="dd/mm/yyyy" name="fechaNacimiento" [maxDate]="maxDate" class="print_hide-on-print"
              [ngClass]="{'ng-invalid ng-dirty': submitted && f.fechaNacimiento.invalid}"
              (onSelect)="calculateAge()" (onBlur)="calculateAge()"
              [disabled]="examen?.modoVista === 'ver' || examen.trabajador.fechaNacimiento">
            </p-calendar>
            <app-invalid-from-message *ngIf="submitted && f.fechaNacimiento.invalid"></app-invalid-from-message>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <app-fiel-title label="Puesto de trabajo" required="true"></app-fiel-title>
            <input [ngClass]="{'ng-invalid ng-dirty': submitted && f.puestoTrabajador.invalid}" alfanumericoDirective
              formControlName="puestoTrabajador" id="puesto" name="puesto" maxlength="100" pInputText type="text"
              [attr.disabled]="examen?.modoVista === 'ver' ? true : null" />
            <span class="print_edadInputNumber_hide print_show-on-print print_filled_input">
              {{examForm.controls.puestoTrabajador.value}}
            </span>
            <app-invalid-from-message *ngIf="submitted && f.puestoTrabajador.invalid"></app-invalid-from-message>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <app-fiel-title label="Fecha de ingreso a la empresa" required="true"></app-fiel-title>
            <span class="print_edadInputNumber_hide print_show-on-print print_filled_input">
              {{examForm.controls.fechaIngresoEmpresa.value | date: "dd/MM/yyyy"}}
            </span>
            <p-calendar formControlName="fechaIngresoEmpresa" [showIcon]="true" dateFormat="dd/mm/yy"
              placeholder="dd/mm/yyyy" name="ingresoEmpresaDate" [maxDate]="maxDateIngreso" class="print_hide-on-print"
              [ngClass]="{'ng-invalid ng-dirty': submitted && f.fechaIngresoEmpresa.invalid}"
              [disabled]="examen?.modoVista === 'ver'">
            </p-calendar>
            <app-invalid-from-message *ngIf="submitted && f.fechaIngresoEmpresa.invalid"></app-invalid-from-message>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <app-fiel-title label="Fecha de ingreso al puesto" required="true"></app-fiel-title>
            <span class="print_edadInputNumber_hide print_show-on-print print_filled_input">
              {{examForm.controls.antiguedadPuestoTrabajador.value | date: "dd/MM/yyyy"}}
            </span>
            <p-calendar formControlName="antiguedadPuestoTrabajador" [showIcon]="true" dateFormat="dd/mm/yy"
              placeholder="dd/mm/yyyy" name="antiguedadDate" class="print_hide-on-print"
              [ngClass]="{'ng-invalid ng-dirty': submitted && f.antiguedadPuestoTrabajador.invalid}"
              [disabled]="examen?.modoVista === 'ver'" [maxDate]="maxDate"
              [minDate]="this.examForm.controls.fechaIngresoEmpresa.value"
              (onSelect)="restrictDateIngresoEmpresa()" (onBlur)="restrictDateIngresoEmpresa()">
            </p-calendar>
            <app-invalid-from-message
              *ngIf="submitted && f.antiguedadPuestoTrabajador.invalid"></app-invalid-from-message>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <app-fiel-title label="Domicilio" required="true"></app-fiel-title>
            <input [ngClass]="{'ng-invalid ng-dirty': submitted && f.calle.invalid}" alfanumericoDirective
              formControlName="calle" id="calle" name="calle" maxlength="100" pInputText type="text"
              [attr.disabled]="examen?.modoVista === 'ver' || examen.trabajador.calle ? true : null" />
            <span class="print_edadInputNumber_hide print_show-on-print print_filled_input">
              {{examForm.controls.calle.value}}
            </span>
            <app-invalid-from-message *ngIf="submitted && f.calle.invalid"></app-invalid-from-message>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <app-fiel-title label="Domicilio Nro" required="true"></app-fiel-title>
            <input [ngClass]="{'ng-invalid ng-dirty': submitted && f.numeroCalle.invalid}" numberDirective
              formControlName="numeroCalle" id="numeroCalle" name="numeroCalle" maxlength="100" pInputText type="text"
              [attr.disabled]="examen?.modoVista === 'ver' || examen.trabajador.numeroCalle ? true : null" />
            <span class="print_edadInputNumber_hide print_show-on-print print_filled_input">
              {{examForm.controls.numeroCalle.value}}
            </span>
            <app-invalid-from-message *ngIf="submitted && f.numeroCalle.invalid"></app-invalid-from-message>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <app-fiel-title label="Piso"></app-fiel-title>
            <input [ngClass]="{'ng-invalid ng-dirty': submitted && f.piso.invalid}" alfanumericoDirective
              formControlName="piso" id="piso" name="piso" maxlength="15" pInputText type="text"
              [attr.disabled]="examen?.modoVista === 'ver' || examen.trabajador.piso ? true : null" />
            <span class="print_edadInputNumber_hide print_show-on-print print_filled_input">
              {{examForm.controls.piso.value}}
            </span>
            <app-invalid-from-message *ngIf="submitted && f.piso.invalid"></app-invalid-from-message>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <app-fiel-title label="Depto"></app-fiel-title>
            <input [ngClass]="{'ng-invalid ng-dirty': submitted && f.departamento.invalid}" alfanumericoDirective
              formControlName="departamento" id="departamento" name="departamento" maxlength="15" pInputText type="text"
              [attr.disabled]="examen?.modoVista === 'ver' || examen.trabajador.departamento ? true : null" />
            <span class="print_edadInputNumber_hide print_show-on-print print_filled_input">
              {{examForm.controls.departamento.value}}
            </span>
            <app-invalid-from-message *ngIf="submitted && f.departamento.invalid"></app-invalid-from-message>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <app-fiel-title label="Localidad" required="true"></app-fiel-title>
            <input [ngClass]="{'ng-invalid ng-dirty': submitted && f.localidad.invalid}" alfanumericoDirective
              formControlName="localidad" id="localidad" name="localidad" maxlength="100" pInputText type="text"
              [attr.disabled]="examen?.modoVista === 'ver' || examen.trabajador.localidad ? true : null" />
            <span class="print_edadInputNumber_hide print_show-on-print print_filled_input">
              {{examForm.controls.localidad.value}}
            </span>
            <app-invalid-from-message *ngIf="submitted && f.localidad.invalid"></app-invalid-from-message>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <app-fiel-title label="CP" required="true"></app-fiel-title>
            <input [ngClass]="{'ng-invalid ng-dirty': submitted && f.codigoPostal.invalid}" alfanumericoDirective
              formControlName="codigoPostal" id="codigoPostal" name="codigoPostal" maxlength="15" pInputText type="text"
              [attr.disabled]="examen?.modoVista === 'ver' || examen.trabajador.codigoPostal ? true : null" />
            <span class="print_edadInputNumber_hide print_show-on-print print_filled_input">
              {{examForm.controls.codigoPostal.value}}
            </span>
            <app-invalid-from-message message="No puede contener espacios en blanco" *ngIf="submitted && cpHasWhiteSpaces"></app-invalid-from-message>
            <app-invalid-from-message *ngIf="submitted && f.codigoPostal.invalid && !cpHasWhiteSpaces"></app-invalid-from-message></div>
          <div class="p-field p-col-12 p-md-4">
            <app-fiel-title label="CPA" required="true"></app-fiel-title>
            <input [ngClass]="{'ng-invalid ng-dirty': submitted && f.codigoPostalArgentino.invalid}" alfanumericoDirective
              formControlName="codigoPostalArgentino" id="codigoPostalArgentino" name="codigoPostalArgentino" maxlength="10" pInputText type="text"
              [attr.disabled]="examen?.modoVista === 'ver' || examen.trabajador.codigoPostalArgentino ? true : null" />
            <span class="print_edadInputNumber_hide print_show-on-print print_filled_input">
              {{examForm.controls.codigoPostalArgentino.value}}
            </span>
            <app-invalid-from-message message="No puede contener espacios en blanco" *ngIf="submitted && cpaHasWhiteSpaces"></app-invalid-from-message>
            <app-invalid-from-message *ngIf="submitted && f.codigoPostalArgentino.invalid && !cpaHasWhiteSpaces"></app-invalid-from-message>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <app-fiel-title label="Teléfono"></app-fiel-title>
            <input [ngClass]="{'ng-invalid ng-dirty': submitted && f.telefono.invalid}" alfanumericoDirective
              formControlName="telefono" id="telefono" name="telefono" maxlength="80" pInputText type="text"
              [attr.disabled]="examen?.modoVista === 'ver' || examen.trabajador.telefono ? true : null" />
            <span class="print_edadInputNumber_hide print_show-on-print print_filled_input">
              {{examForm.controls.telefono.value}}
            </span>
            <app-invalid-from-message *ngIf="submitted && f.telefono.invalid"></app-invalid-from-message>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <app-fiel-title label="Edad"></app-fiel-title>
            <p class="readOnly">
              {{ examen.trabajador.edad }} años
            </p>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <app-fiel-title label="Sector" required="true"></app-fiel-title>
            <input [ngClass]="{'ng-invalid ng-dirty': submitted && f.sector.invalid}" alfanumericoDirective
              formControlName="sector" id="sector" name="sector" maxlength="15" pInputText type="text"
              [attr.disabled]="examen?.modoVista === 'ver' || examen.trabajador.sector ? true : null" />
            <span class="print_edadInputNumber_hide print_show-on-print print_filled_input">
              {{examForm.controls.sector.value}}
            </span>
            <app-invalid-from-message *ngIf="submitted && f.sector.invalid"></app-invalid-from-message>
          </div>
        </div>
        <div *ngIf="configForm.findField('realizacionExamenPreocupacional')" class="p-grid p-grid-space print_dont_break">
          <div class="p-col-12 p-md-12">
            <app-fiel-title label="¿Le realizaron estudio preocupacional?" required="true"></app-fiel-title>
            <div style="display: flex; flex-direction: row;" [ngClass]="{'ng-invalid ng-dirty': submitted && f.realizacionExamenPreocupacional.invalid }">
              <p-radioButton (onClick)="clickRadioButton('SI', 'PREOCUPACIONAL')" name="realizacionExamenPreocupacional"
                [value]="true" formControlName="realizacionExamenPreocupacional" [disabled]="examen?.modoVista === 'ver'"
                label="Si" [ngClass]="{'ng-invalid ng-dirty': submitted && f.realizacionExamenPreocupacional.invalid}">
              </p-radioButton>
              <p-radioButton name="realizacionExamenPreocupacional" [value]="false" formControlName="realizacionExamenPreocupacional"
                label="No" [ngClass]="{'ng-invalid ng-dirty': submitted && f.realizacionExamenPreocupacional.invalid}"
                [disabled]="examen?.modoVista === 'ver'" (onClick)="clickRadioButton('NO', 'PREOCUPACIONAL')">
              </p-radioButton>
            </div>
            <app-invalid-from-message *ngIf="submitted && f.realizacionExamenPreocupacional.invalid"></app-invalid-from-message>
          </div>
          <div class="p-col-12 p-md-6 print_row-full">
            <app-fiel-title label="Observaciones"></app-fiel-title>
            <p [ngClass]="{'print_show-on-print': f.examenPreocupacionalObservacion.value.length > 0,
              'print_hide-on-print': f.examenPreocupacionalObservacion.value.length < 1}"
              class="print_hidden-area-before-print print_row-full p-field-word-break">
              {{f.examenPreocupacionalObservacion.value}}
            </p>
            <textarea class="print_hide-on-print"
              [ngClass]="{'ng-invalid ng-dirty': submitted && f.examenPreocupacionalObservacion.invalid}" cols="30"
              formControlName="examenPreocupacionalObservacion" id="result" maxlength="1000" name="resul"
              pInputTextarea rows="5" [attr.disabled]="examen?.modoVista === 'ver' ? true : null">
            </textarea>
            <small style="text-align: end;">
              {{ f.examenPreocupacionalObservacion.value.length }}/1000
            </small>
            <app-invalid-from-message *ngIf="submitted && f.examenPreocupacionalObservacion.errors?.required">
            </app-invalid-from-message>
            <app-invalid-from-message *ngIf="f.examenPreocupacionalObservacion.errors?.maxlength"
              message="Solo se permiten {{ f.examenPreocupacionalObservacion.errors.maxlength.requiredLength  }} caracteres">
            </app-invalid-from-message>
          </div>
        </div>
      </div>

      <!-- Seccion Prestador (Solo para modo imprimir) -->
      <div class="p_hidden print_show-on-print">
        <div class="p-grid p-mt-2">
          <span class="p-title-seccion">
            Datos Del Prestador
          </span>
        </div>
        <div class="p-grid">
          <div class="p-field p-col-12 p-md-4">
            <app-fiel-title label="Código del prestador"></app-fiel-title>
            <p class="readOnly">
              {{currentUser.modelCode}}
            </p>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <app-fiel-title label="Razón social"></app-fiel-title>
            <p class="readOnly">
              {{currentUser.modelName}}
            </p>
          </div>
        </div>
      </div>

      <!-- ----------------------------------3.Datos Clínicos ---------------------------------- -->
      <div *ngIf="configForm.findSection('Datos clínicos')">
        <div class="p-grid p-mt-2">
          <span class="p-title-seccion">
            {{ configForm.findNumberSection("Datos clínicos") }}.Datos Clínicos
          </span>
        </div>
        <p-divider></p-divider>
        <div class="p-grid">
          <!--Campo sintomasActividadLaboral-->
          <div class="p-col-12 p-md-12">
            <div class="p-col-12 p-md-12 print_dont_break">
              <app-fiel-title label="¿Atribuye síntomas a su actividad laboral?" required="true"></app-fiel-title>
              <div style="display: flex; flex-direction: row;" [ngClass]="{'ng-invalid ng-dirty': submitted && f.sintomasActividadLaboral.invalid }">
                <p-radioButton name="sintomasActividadLaboral" [value]="true" formControlName="sintomasActividadLaboral"
                  label="Si" [ngClass]="{'ng-invalid ng-dirty': submitted && f.sintomasActividadLaboral.invalid}"
                  [disabled]="examen?.modoVista === 'ver'" (onClick)="clickRadioButton('SI', 'SINTOMAS')">
                </p-radioButton>
                <p-radioButton name="sintomasActividadLaboral" [value]="false" formControlName="sintomasActividadLaboral"
                  label="No" [ngClass]="{'ng-invalid ng-dirty': submitted && f.sintomasActividadLaboral.invalid}"
                  [disabled]="examen?.modoVista === 'ver'" (onClick)="clickRadioButton('NO', 'SINTOMAS')">
                </p-radioButton>
              </div>
              <app-invalid-from-message *ngIf="submitted && f.sintomasActividadLaboral.invalid"></app-invalid-from-message>
            </div>
            <div class="p-col-12 p-md-6 print_row-full print_dont_break">
              <app-fiel-title label="Describa"></app-fiel-title>
              <p [ngClass]="{'print_show-on-print': f.descripcionSintomasActividadLaboral.value.length > 0,
                'print_hide-on-print': f.descripcionSintomasActividadLaboral.value.length < 1}"
                class="print_hidden-area-before-print print_row-full p-field-word-break">
                {{f.descripcionSintomasActividadLaboral.value}}
              </p>
              <textarea class="print_hide-on-print"
                [ngClass]="{'ng-invalid ng-dirty': submitted && f.descripcionSintomasActividadLaboral.invalid}" cols="30"
                formControlName="descripcionSintomasActividadLaboral" id="result" maxlength="1000" name="resul"
                pInputTextarea rows="5" [attr.disabled]="examen?.modoVista === 'ver' ? true : null">
              </textarea>
              <small style="text-align: end;">
                {{ f.descripcionSintomasActividadLaboral.value.length }}/1000
              </small>
              <app-invalid-from-message *ngIf="submitted && f.descripcionSintomasActividadLaboral.errors?.required">
              </app-invalid-from-message>
              <app-invalid-from-message *ngIf="f.descripcionSintomasActividadLaboral.errors?.maxlength"
                message="Solo se permiten {{ f.descripcionSintomasActividadLaboral.errors.maxlength.requiredLength  }} caracteres">
              </app-invalid-from-message>
            </div>
          </div>
          <!--Campo antecedentesPersonalesEnfermedades-->
          <div class="p-col-12 p-md-12">
            <div class="p-col-12 p-md-12 print_dont_break">
              <app-fiel-title label="Antecedentes personales de enfermedades" required="true"></app-fiel-title>
              <div style="display: flex; flex-direction: row;" [ngClass]="{'ng-invalid ng-dirty': submitted && f.antecedentesPersonalesEnfermedades.invalid }">
                <p-radioButton name="antecedentesPersonalesEnfermedades" [value]="true" formControlName="antecedentesPersonalesEnfermedades"
                  label="Si" [ngClass]="{'ng-invalid ng-dirty': submitted && f.antecedentesPersonalesEnfermedades.invalid}"
                  [disabled]="examen?.modoVista === 'ver'" (onClick)="clickRadioButton('SI', 'ANTECEDENTES')">
                </p-radioButton>
                <p-radioButton name="antecedentesPersonalesEnfermedades" [value]="false" formControlName="antecedentesPersonalesEnfermedades"
                  label="No" [ngClass]="{'ng-invalid ng-dirty': submitted && f.antecedentesPersonalesEnfermedades.invalid}"
                  [disabled]="examen?.modoVista === 'ver'" (onClick)="clickRadioButton('NO', 'ANTECEDENTES')">
                </p-radioButton>
              </div>
              <app-invalid-from-message *ngIf="submitted && f.antecedentesPersonalesEnfermedades.invalid"></app-invalid-from-message>
            </div>
            <div class="p-col-12 p-md-6 print_row-full print_dont_break">
              <app-fiel-title label="Observaciones"></app-fiel-title>
              <p [ngClass]="{'print_show-on-print': f.observacionesAntecedentesPersonales.value.length > 0,
                'print_hide-on-print': f.observacionesAntecedentesPersonales.value.length < 1}"
                class="print_hidden-area-before-print print_row-full p-field-word-break">
                {{f.observacionesAntecedentesPersonales.value}}
              </p>
              <textarea class="print_hide-on-print"
                [ngClass]="{'ng-invalid ng-dirty': submitted && f.observacionesAntecedentesPersonales.invalid}" cols="30"
                formControlName="observacionesAntecedentesPersonales" id="result" maxlength="1000" name="resul"
                pInputTextarea rows="5" [attr.disabled]="examen?.modoVista === 'ver' ? true : null">
              </textarea>
              <small style="text-align: end;">
                {{ f.observacionesAntecedentesPersonales.value.length }}/1000
              </small>
              <app-invalid-from-message *ngIf="submitted && f.observacionesAntecedentesPersonales.errors?.required">
              </app-invalid-from-message>
              <app-invalid-from-message *ngIf="f.observacionesAntecedentesPersonales.errors?.maxlength"
                message="Solo se permiten {{ f.observacionesAntecedentesPersonales.errors.maxlength.requiredLength  }} caracteres">
              </app-invalid-from-message>
            </div>
          </div>
          <!--Campo Realiza Tratamiento-->
          <div class="p-col-12 p-md-12">
            <div class="p-col-12 p-md-12 print_dont_break">
              <app-fiel-title label="¿Está realizando algún tratamiento?"></app-fiel-title>
              <div style="display: flex; flex-direction: row;" [ngClass]="{'ng-invalid ng-dirty': submitted && f.realizaTratamiento.invalid }">
                <p-radioButton name="realizaTratamiento" [value]="true" formControlName="realizaTratamiento"
                  label="Si" [ngClass]="{'ng-invalid ng-dirty': submitted && f.realizaTratamiento.invalid}"
                  [disabled]="examen?.modoVista === 'ver'" (onClick)="clickRadioButton('SI', 'TRATAMIENTO')">
                </p-radioButton>
                <p-radioButton name="realizaTratamiento" [value]="false" formControlName="realizaTratamiento"
                  label="No" [ngClass]="{'ng-invalid ng-dirty': submitted && f.realizaTratamiento.invalid}"
                  [disabled]="examen?.modoVista === 'ver'" (onClick)="clickRadioButton('NO', 'TRATAMIENTO')">
                </p-radioButton>
              </div>
              <app-invalid-from-message *ngIf="submitted && f.realizaTratamiento.invalid"></app-invalid-from-message>
            </div>
            <div class="p-col-12 p-md-6 print_row-full print_dont_break">
              <app-fiel-title label="Describa"></app-fiel-title>
              <p [ngClass]="{'print_show-on-print': f.descripcionTratamiento.value.length > 0,
                'print_hide-on-print': f.descripcionTratamiento.value.length < 1}"
                class="print_hidden-area-before-print print_row-full p-field-word-break">
                {{f.descripcionTratamiento.value}}
              </p>
              <textarea class="print_hide-on-print"
                [ngClass]="{'ng-invalid ng-dirty': submitted && f.descripcionTratamiento.invalid}" cols="30"
                formControlName="descripcionTratamiento" id="result" maxlength="1000" name="resul"
                pInputTextarea rows="5" [attr.disabled]="examen?.modoVista === 'ver' ? true : null">
              </textarea>
              <small style="text-align: end;">
                {{ f.descripcionTratamiento.value.length }}/1000
              </small>
              <app-invalid-from-message *ngIf="submitted && f.descripcionTratamiento.errors?.required">
              </app-invalid-from-message>
              <app-invalid-from-message *ngIf="f.descripcionTratamiento.errors?.maxlength"
                message="Solo se permiten {{ f.descripcionTratamiento.errors.maxlength.requiredLength  }} caracteres">
              </app-invalid-from-message>
            </div>
          </div>
          <!--Campo Toma Medicamentos-->
          <div class="p-col-12 p-md-12">
            <div class="p-col-12 p-md-12 print_dont_break">
              <app-fiel-title label="¿Toma medicamentos?"></app-fiel-title>
              <div style="display: flex; flex-direction: row;" [ngClass]="{'ng-invalid ng-dirty': submitted && f.tomaMedicamentos.invalid }">
                <p-radioButton name="tomaMedicamentos" [value]="true" formControlName="tomaMedicamentos"
                  label="Si" [ngClass]="{'ng-invalid ng-dirty': submitted && f.tomaMedicamentos.invalid}"
                  [disabled]="examen?.modoVista === 'ver'" (onClick)="clickRadioButton('SI', 'MEDICAMENTOS')">
                </p-radioButton>
                <p-radioButton name="tomaMedicamentos" [value]="false" formControlName="tomaMedicamentos"
                  label="No" [ngClass]="{'ng-invalid ng-dirty': submitted && f.tomaMedicamentos.invalid}"
                  [disabled]="examen?.modoVista === 'ver'" (onClick)="clickRadioButton('NO', 'MEDICAMENTOS')">
                </p-radioButton>
              </div>
              <app-invalid-from-message *ngIf="submitted && f.tomaMedicamentos.invalid"></app-invalid-from-message>
            </div>
            <div class="p-col-12 p-md-6 print_row-full print_dont_break">
              <app-fiel-title label="Detallar"></app-fiel-title>
              <p [ngClass]="{'print_show-on-print': f.detalleTomaMedicamentos.value.length > 0,
                'print_hide-on-print': f.detalleTomaMedicamentos.value.length < 1}"
                class="print_hidden-area-before-print print_row-full p-field-word-break">
                {{f.detalleTomaMedicamentos.value}}
              </p>
              <textarea class="print_hide-on-print"
                [ngClass]="{'ng-invalid ng-dirty': submitted && f.detalleTomaMedicamentos.invalid}" cols="30"
                formControlName="detalleTomaMedicamentos" id="result" maxlength="1000" name="resul"
                pInputTextarea rows="5" [attr.disabled]="examen?.modoVista === 'ver' ? true : null">
              </textarea>
              <small style="text-align: end;">
                {{ f.detalleTomaMedicamentos.value.length }}/1000
              </small>
              <app-invalid-from-message *ngIf="submitted && f.detalleTomaMedicamentos.errors?.required">
              </app-invalid-from-message>
              <app-invalid-from-message *ngIf="f.detalleTomaMedicamentos.errors?.maxlength"
                message="Solo se permiten {{ f.detalleTomaMedicamentos.errors.maxlength.requiredLength  }} caracteres">
              </app-invalid-from-message>
            </div>
          </div>
          <!--Campos Peso Talla IMC-->
          <div class="p-field p-col-12 p-md-4">
            <app-fiel-title label="Peso" required="true"></app-fiel-title>
            <span class="print_edadInputNumber_hide print_show-on-print print_filled_input">
              {{f.peso.value}}
            </span>
            <p-inputNumber class="print_hide-on-print" [ngClass]="{'ng-invalid ng-dirty': submitted && f.peso.invalid}"
              formControlName="peso" id="peso" [minFractionDigits]="2" [maxFractionDigits]="2"
              name="peso" [disabled]="examen?.modoVista === 'ver'">
            </p-inputNumber>
            <app-invalid-from-message *ngIf="submitted && f.peso.errors?.required"></app-invalid-from-message>
            <app-invalid-from-message *ngIf="submitted && (f.peso.errors?.min || f.peso.errors?.max)"
              message="Solo se permiten valores entre 40 y 180"></app-invalid-from-message>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <app-fiel-title label="Talla" required="true"></app-fiel-title>
            <span class="print_edadInputNumber_hide print_show-on-print print_filled_input">
              {{f.talla.value}}
            </span>
            <p-inputNumber class="print_hide-on-print" [ngClass]="{'ng-invalid ng-dirty': submitted && f.talla.invalid}"
              formControlName="talla" id="talla"
              name="talla" maxlength="3" [disabled]="examen?.modoVista === 'ver'">
            </p-inputNumber>
            <app-invalid-from-message *ngIf="submitted && f.talla.errors?.required"></app-invalid-from-message>
            <app-invalid-from-message *ngIf="submitted && (f.talla.errors?.min || f.talla.errors?.max)"
              message="Solo se permiten valores entre 100 y 220"></app-invalid-from-message>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <app-fiel-title label="IMC" required="true"></app-fiel-title>
            <span class="print_edadInputNumber_hide print_show-on-print print_filled_input">
              {{f.indiceMasaCorporal.value}}
            </span>
            <div style="display: flex; flex-wrap: wrap; margin-right: -0.5rem; margin-left: -0.5rem;">
                <div class="p-field p-col-12 p-md-6" style="margin-bottom: 0;">
                  <p-inputNumber class="print_hide-on-print" [ngClass]="{'ng-invalid ng-dirty': submitted && f.indiceMasaCorporal.invalid}"
                    formControlName="indiceMasaCorporal" id="indiceMasaCorporal"
                    name="indiceMasaCorporal" [readonly]="true" [disabled]="examen?.modoVista === 'ver'">
                  </p-inputNumber>
                  <app-invalid-from-message *ngIf="submitted && f.indiceMasaCorporal.errors?.required && (!f.talla.invalid && !f.peso.invalid)"
                    message="Debe calcular el IMC">
                  </app-invalid-from-message>
                </div>
              <div class="p-col-12 p-md-6 print_hide-on-print">
                <button [disabled]="examen?.modoVista === 'ver' ? true : null" pButton pRipple type="button" label="Calcular IMC" (click)="calcularImc()"></button>
              </div>
            </div>
            <app-invalid-from-message *ngIf="submitted && f.indiceMasaCorporal.errors?.required && (f.talla.errors?.required || f.peso.errors?.required)"></app-invalid-from-message>
          </div>
          <!--Campos Frecuencia Presion Sistolica y Presion Diastolica -- frecuenciaPulso hace referencia a Frecuencia Cardíaca-->
          <div class="p-field p-col-12 p-md-4">
            <app-fiel-title label="Frecuencia Cardíaca" required="true"></app-fiel-title>
            <span class="print_edadInputNumber_hide print_show-on-print print_filled_input">
              {{f.frecuenciaPulso.value}}
            </span>
            <p-inputNumber class="print_hide-on-print" [ngClass]="{'ng-invalid ng-dirty': submitted && f.frecuenciaPulso.invalid}"
              formControlName="frecuenciaPulso" id="frecuenciaPulso"
              name="frecuenciaPulso" maxlength="3" [disabled]="examen?.modoVista === 'ver'">
            </p-inputNumber>
            <app-invalid-from-message *ngIf="submitted && f.frecuenciaPulso.errors?.required"></app-invalid-from-message>
            <app-invalid-from-message *ngIf="submitted && (f.frecuenciaPulso.errors?.min || f.frecuenciaPulso.errors?.max)"
              message="Solo se permiten valores entre 35 y 220"></app-invalid-from-message>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <app-fiel-title label="Presión Sistólica" required="true"></app-fiel-title>
            <span class="print_edadInputNumber_hide print_show-on-print print_filled_input">
              {{f.presionSistolica.value}}
            </span>
            <p-inputNumber class="print_hide-on-print" [ngClass]="{'ng-invalid ng-dirty': submitted && f.presionSistolica.invalid}"
              formControlName="presionSistolica" id="presionSistolica"
              name="presionSistolica" maxlength="3" [disabled]="examen?.modoVista === 'ver'">
            </p-inputNumber>
            <app-invalid-from-message *ngIf="submitted && f.presionSistolica.errors?.required"></app-invalid-from-message>
            <app-invalid-from-message *ngIf="submitted && (f.presionSistolica.errors?.min || f.presionSistolica.errors?.max)"
              message="Solo se permiten valores entre 50 y 300"></app-invalid-from-message>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <app-fiel-title label="Presión Diastólica" required="true"></app-fiel-title>
            <span class="print_edadInputNumber_hide print_show-on-print print_filled_input">
              {{f.presionDiastolica.value}}
            </span>
            <p-inputNumber class="print_hide-on-print" [ngClass]="{'ng-invalid ng-dirty': submitted && f.presionDiastolica.invalid}"
              formControlName="presionDiastolica" id="presionDiastolica"
              name="presionDiastolica" maxlength="3" [disabled]="examen?.modoVista === 'ver'">
            </p-inputNumber>
            <app-invalid-from-message *ngIf="submitted && f.presionDiastolica.errors?.required"></app-invalid-from-message>
            <app-invalid-from-message *ngIf="submitted && (f.presionDiastolica.errors?.min || f.presionDiastolica.errors?.max)"
              message="Solo se permiten valores entre 50 y 150"></app-invalid-from-message>
          </div>
          <!--Campo Tabaquismo-->
          <div class="p-col-12 p-md-12 print_dont_break">
            <app-fiel-title label="Tabaquismo" required="true"></app-fiel-title>
            <div class="p-field-checkbox-inline" style="display: flex; flex-direction: row;">
              <div class="p-field-checkbox">
                <p-checkbox (onChange)="clickCheckBox('noFumador', $event)" binary="true"
                  [ngClass]="{'ng-invalid ng-dirty': submitted && !f.noFumador.value && !f.fumador.value && !f.exFumador.value}"
                  formControlName="noFumador" inputId="noFumador" label="No Fuma" name="noFumador"
                  [disabled]="examen?.modoVista === 'ver'">
                </p-checkbox>
              </div>
              <div class="p-field-checkbox">
                <p-checkbox (onChange)="clickCheckBox('fumador', $event)" binary="true"
                  [ngClass]="{'ng-invalid ng-dirty': submitted && !f.noFumador.value && !f.fumador.value && !f.exFumador.value}"
                  formControlName="fumador" inputId="fumador" label="Fuma" name="fumador"
                  [ngModel]="examen.noFumador === false && examen.exFumador === false" [disabled]="examen?.modoVista === 'ver'">
                </p-checkbox>
              </div>
              <div class="p-field-checkbox">
                <p-checkbox (onChange)="clickCheckBox('exFumador', $event)" binary="true"
                  [ngClass]="{'ng-invalid ng-dirty': submitted && !f.noFumador.value && !f.fumador.value && !f.exFumador.value}"
                  formControlName="exFumador" inputId="exFumador" label="Ex Fumador" name="exFumador"
                  [ngModel]="examen.exFumador" [disabled]="examen?.modoVista === 'ver'">
                </p-checkbox>
              </div>
            </div>
            <app-invalid-from-message *ngIf="submitted && !f.noFumador.value && !f.fumador.value && !f.exFumador.value"></app-invalid-from-message>
          </div>
          <!--Campo Tabaquismo Cantidad-->
          <div class="p-col-12 p-md-12 print_dont_break">
            <app-fiel-title label="Cantidad de cigarrillos"></app-fiel-title>
            <div class="p-field-checkbox-inline" style="display: flex; flex-direction: row;" [ngClass]="{'ng-invalid ng-dirty': submitted &&
              !f.fumaUnoDiez.value && !f.fumador.value && !f.exFumador.value}">
              <div class="p-field-checkbox">
                <p-checkbox (onChange)="clickCheckBox('fumaUnoDiez', $event)" binary="true"
                  [ngClass]="{'ng-invalid ng-dirty': submitted && (f.fumador.value || f.exFumador.value) && !f.fumaUnoDiez.value &&
                  !f.fumaOnceVeinte.value && !f.fumaMasVeinte.value}"
                  formControlName="fumaUnoDiez" inputId="fumaUnoDiez" label="1 a 10 cigarrillos" name="fumaUnoDiez"
                  [disabled]="examen?.modoVista === 'ver'">
                </p-checkbox>
              </div>
              <div class="p-field-checkbox">
                <p-checkbox (onChange)="clickCheckBox('fumaOnceVeinte', $event)" binary="true"
                  [ngClass]="{'ng-invalid ng-dirty': submitted && (f.fumador.value || f.exFumador.value) && !f.fumaUnoDiez.value &&
                  !f.fumaOnceVeinte.value && !f.fumaMasVeinte.value}"
                  formControlName="fumaOnceVeinte" inputId="fumaOnceVeinte" label="11 a 20 cigarrillos" name="fumaOnceVeinte"
                  [disabled]="examen?.modoVista === 'ver'">
                </p-checkbox>
              </div>
              <div class="p-field-checkbox">
                <p-checkbox (onChange)="clickCheckBox('fumaMasVeinte', $event)" binary="true"
                  [ngClass]="{'ng-invalid ng-dirty': submitted && (f.fumador.value || f.exFumador.value) && !f.fumaUnoDiez.value &&
                  !f.fumaOnceVeinte.value && !f.fumaMasVeinte.value}"
                  formControlName="fumaMasVeinte" inputId="fumaMasVeinte" label="Más de 20 cigarrillos" name="fumaMasVeinte"
                  [disabled]="examen?.modoVista === 'ver'">
                </p-checkbox>
              </div>
            </div>
            <app-invalid-from-message *ngIf="submitted && (f.fumador.value || f.exFumador.value) && !f.fumaUnoDiez.value && !f.fumaOnceVeinte.value
              && !f.fumaMasVeinte.value"></app-invalid-from-message>
          </div>
          <div class="p-field p-col-12 p-md-12 print_dont_break">
            <app-fiel-title *ngIf="!f.exFumador.value" label="Hace cuánto tiempo fuma"></app-fiel-title>
            <app-fiel-title *ngIf="f.exFumador.value" label="Hace cuánto dejó de fumar"></app-fiel-title>
            <div style="display: flex; flex-direction: row; align-items: center;">
              <div class="p-col-12 p-md-2" style="padding-left: 0;">
                <span class="print_edadInputNumber_hide print_show-on-print print_filled_input">
                  {{f.cantidadFuma.value}} {{f.unidadTiempo.value}}
                </span>
                <p-inputNumber class="print_hide-on-print" [ngClass]="{'ng-invalid ng-dirty': submitted && f.cantidadFuma.invalid}"
                  formControlName="cantidadFuma" id="cantidadFuma" name="cantidadFuma" [disabled]="examen?.modoVista === 'ver'"
                  maxlength="4" [useGrouping]="false">
                </p-inputNumber>
              </div>
              <div class="p-col-12 p-md-2">
                <p-dropdown class="print_hide-on-print" [ngClass]="{'ng-invalid ng-dirty': submitted && f.unidadTiempo.invalid}"
                  [options]="unidadesTiempoTabaquismo" formControlName="unidadTiempo" placeholder="Seleccione"
                  optionLabel="label" optionValue="value" [showClear]="true"
                  [disabled]="examen?.modoVista === 'ver'">
                </p-dropdown>
              </div>
            </div>
            <app-invalid-from-message *ngIf="submitted && (f.cantidadFuma.invalid || f.unidadTiempo.invalid)"></app-invalid-from-message>
          </div>
          <!--Campo Alcohol-->
          <div class="p-col-12 p-md-12 print_dont_break">
            <app-fiel-title label="Alcohol" required="true"></app-fiel-title>
            <div style="display: flex; flex-direction: row; white-space: nowrap" [ngClass]="{'ng-invalid ng-dirty': submitted && f.consumeAlcohol.invalid }">
              <p-radioButton name="consumeAlcohol" [value]="true" formControlName="consumeAlcohol"
                label="Consume" [ngClass]="{'ng-invalid ng-dirty': submitted && f.consumeAlcohol.invalid}"
                [disabled]="examen?.modoVista === 'ver'" (onClick)="clickRadioButton('SI', 'ALCOHOL')">
              </p-radioButton>
              <p-radioButton name="consumeAlcohol" [value]="false" formControlName="consumeAlcohol"
                label="No Consume" [ngClass]="{'ng-invalid ng-dirty': submitted && f.consumeAlcohol.invalid}"
                [disabled]="examen?.modoVista === 'ver'" (onClick)="clickRadioButton('NO', 'ALCOHOL')">
              </p-radioButton>
            </div>
            <app-invalid-from-message *ngIf="submitted && f.consumeAlcohol.invalid"></app-invalid-from-message>
          </div>
          <!--Campos Cantidad y Tipo Alcohol-->
          <div class="p-field p-col-12 p-md-3">
            <app-fiel-title label="Cantidad"></app-fiel-title>
            <span class="print_edadInputNumber_hide print_show-on-print print_filled_input">
              {{f.cantidadAlcohol.value}}
            </span>
            <input [ngClass]="{'ng-invalid ng-dirty': submitted && f.cantidadAlcohol.invalid}" numberDirective
              formControlName="cantidadAlcohol" id="cantidadAlcohol" name="cantidadAlcohol" maxlength="100" pInputText type="text"
              [attr.disabled]="examen?.modoVista === 'ver' ? true : null" />
            <app-invalid-from-message *ngIf="submitted && f.cantidadAlcohol.invalid"></app-invalid-from-message>
          </div>
          <div class="p-field p-col-12 p-md-3">
            <app-fiel-title label="Tipo"></app-fiel-title>
            <span class="print_edadInputNumber_hide print_show-on-print print_filled_input">
              {{f.tipoAlcohol.value}}
            </span>
            <input [ngClass]="{'ng-invalid ng-dirty': submitted && f.tipoAlcohol.invalid}"
              formControlName="tipoAlcohol" id="tipoAlcohol" name="tipoAlcohol" maxlength="25" pInputText type="text"
              [attr.disabled]="examen?.modoVista === 'ver' ? true : null" />
            <app-invalid-from-message *ngIf="submitted && f.tipoAlcohol.invalid"></app-invalid-from-message>
          </div>
        </div>
      </div>

      <!-- ----------------------------------4.Estudio---------------------------------- -->
      <div *ngIf="configForm.findSection('Estudio')">
        <div class="p-grid p-mt-2">
          <span class="p-title-seccion">
            {{ configForm.findNumberSection("Estudio") }}.Estudio
          </span>
        </div>
        <p-divider></p-divider>
        <div class="p-grid">
          <!--PIEL-->
          <div *ngIf="configForm.findSection('Piel')" class="p-col-12 p-md-12">
            <div class="p-col-12 p-md-12 print_dont_break">
              <app-fiel-title label="Piel con alteraciones" required="true"></app-fiel-title>
              <div style="display: flex; flex-direction: row; white-space: nowrap" [ngClass]="{'ng-invalid ng-dirty': submitted && f.pielAlteraciones.invalid }">
                <p-radioButton (onClick)="clickRadioButton('SI', 'PIEL')" name="pielAlteraciones" [value]="true"
                  formControlName="pielAlteraciones" label="Si" [ngClass]="{'ng-invalid ng-dirty': submitted && f.pielAlteraciones.invalid}"
                  [disabled]="examen?.modoVista === 'ver'">
                </p-radioButton>
                <p-radioButton (onClick)="clickRadioButton('NO', 'PIEL')" name="pielAlteraciones" [value]="false" formControlName="pielAlteraciones"
                  label="Se examinó y no presentó alteraciones" [ngClass]="{'ng-invalid ng-dirty': submitted && f.pielAlteraciones.invalid}"
                  [disabled]="examen?.modoVista === 'ver'">
                </p-radioButton>
              </div>
              <app-invalid-from-message *ngIf="submitted && f.pielAlteraciones.invalid"></app-invalid-from-message>
            </div>
            <div class="p-col-12 p-md-8 print_dont_break">
              <app-fiel-title label="Alteraciones"></app-fiel-title>
              <div class="print_row-half" style="display: flex; white-space: nowrap;">
                <div class="p-md-3">
                  <div class="p-field-checkbox">
                    <p-checkbox binary="true" [ngClass]="{'ng-invalid ng-dirty': submitted && f.pielAlteraciones.value && !f.prurito.value
                        && !f.vesiculas.value && !f.eritema.value && !f.ulceracion.value && !f.botonAceite.value && !f.hiperpigmentacion.value
                        && !f.hipopigmentacion.value && !f.eczema.value && !f.otrosPielAlteraciones.value && !f.fisuras.value
                        && !f.hiperqueratosis.value && !f.petequias.value && !f.onicomicosis.value}"
                      formControlName="vesiculas" inputId="vesiculas" label="Vesículas" name="vesiculas"
                      [ngModel]="examen.vesiculas" [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </div>
                  <div class="p-field-checkbox">
                    <p-checkbox binary="true" [ngClass]="{'ng-invalid ng-dirty': submitted && f.pielAlteraciones.value && !f.prurito.value
                        && !f.vesiculas.value && !f.eritema.value && !f.ulceracion.value && !f.botonAceite.value && !f.hiperpigmentacion.value
                        && !f.hipopigmentacion.value && !f.eczema.value && !f.otrosPielAlteraciones.value && !f.fisuras.value
                        && !f.hiperqueratosis.value && !f.petequias.value && !f.onicomicosis.value}"
                      formControlName="botonAceite" inputId="botonAceite" label="Botón de Aceite" name="botonAceite"
                      [ngModel]="examen.botonAceite" [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </div>
                  <div class="p-field-checkbox">
                    <p-checkbox binary="true" [ngClass]="{'ng-invalid ng-dirty': submitted && f.pielAlteraciones.value && !f.prurito.value
                        && !f.vesiculas.value && !f.eritema.value && !f.ulceracion.value && !f.botonAceite.value && !f.hiperpigmentacion.value
                        && !f.hipopigmentacion.value && !f.eczema.value && !f.otrosPielAlteraciones.value && !f.fisuras.value
                        && !f.hiperqueratosis.value && !f.petequias.value && !f.onicomicosis.value}"
                      formControlName="eczema" inputId="eczema" label="Eczema" name="eczema"
                      [ngModel]="examen.eczema" [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </div>
                  <div class="p-field-checkbox">
                    <p-checkbox (onChange)="clickCheckBox('otrosPielAlteraciones', $event)" binary="true"
                      [ngClass]="{'ng-invalid ng-dirty': submitted && f.pielAlteraciones.value && !f.prurito.value
                        && !f.vesiculas.value && !f.eritema.value && !f.ulceracion.value && !f.botonAceite.value && !f.hiperpigmentacion.value
                        && !f.hipopigmentacion.value && !f.eczema.value && !f.otrosPielAlteraciones.value && !f.fisuras.value
                        && !f.hiperqueratosis.value && !f.petequias.value && !f.onicomicosis.value}"
                      formControlName="otrosPielAlteraciones" inputId="otrosPielAlteraciones" label="Otros" name="otrosPielAlteraciones"
                      [ngModel]="examen.otrosPielAlteraciones" [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </div>
                </div>
                <div class="p-md-3">
                  <div class="p-field-checkbox">
                    <p-checkbox binary="true" [ngClass]="{'ng-invalid ng-dirty': submitted && f.pielAlteraciones.value && !f.prurito.value
                        && !f.vesiculas.value && !f.eritema.value && !f.ulceracion.value && !f.botonAceite.value && !f.hiperpigmentacion.value
                        && !f.hipopigmentacion.value && !f.eczema.value && !f.otrosPielAlteraciones.value && !f.fisuras.value
                        && !f.hiperqueratosis.value && !f.petequias.value && !f.onicomicosis.value}"
                      formControlName="prurito" inputId="prurito" label="Prurito" name="prurito"
                      [ngModel]="examen.prurito" [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </div>
                  <div class="p-field-checkbox">
                    <p-checkbox binary="true" [ngClass]="{'ng-invalid ng-dirty': submitted && f.pielAlteraciones.value && !f.prurito.value
                        && !f.vesiculas.value && !f.eritema.value && !f.ulceracion.value && !f.botonAceite.value && !f.hiperpigmentacion.value
                        && !f.hipopigmentacion.value && !f.eczema.value && !f.otrosPielAlteraciones.value && !f.fisuras.value
                        && !f.hiperqueratosis.value && !f.petequias.value && !f.onicomicosis.value}"
                      formControlName="hiperpigmentacion" inputId="hiperpigmentacion" label="Hiperpigmentación" name="hiperpigmentacion"
                      [ngModel]="examen.hiperpigmentacion" [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </div>
                  <div class="p-field-checkbox">
                    <p-checkbox binary="true" [ngClass]="{'ng-invalid ng-dirty': submitted && f.pielAlteraciones.value && !f.prurito.value
                        && !f.vesiculas.value && !f.eritema.value && !f.ulceracion.value && !f.botonAceite.value && !f.hiperpigmentacion.value
                        && !f.hipopigmentacion.value && !f.eczema.value && !f.otrosPielAlteraciones.value && !f.fisuras.value
                        && !f.hiperqueratosis.value && !f.petequias.value && !f.onicomicosis.value}"
                      formControlName="hipopigmentacion" inputId="hipopigmentacion" label="Hipopigmentación" name="hipopigmentacion"
                      [ngModel]="examen.hipopigmentacion" [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </div>
                </div>
                <div class="p-md-3">
                  <div class="p-field-checkbox">
                    <p-checkbox binary="true" [ngClass]="{'ng-invalid ng-dirty': submitted && f.pielAlteraciones.value && !f.prurito.value
                        && !f.vesiculas.value && !f.eritema.value && !f.ulceracion.value && !f.botonAceite.value && !f.hiperpigmentacion.value
                        && !f.hipopigmentacion.value && !f.eczema.value && !f.otrosPielAlteraciones.value && !f.fisuras.value
                        && !f.hiperqueratosis.value && !f.petequias.value && !f.onicomicosis.value}"
                      formControlName="eritema" inputId="eritema" label="Eritema" name="eritema"
                      [ngModel]="examen.eritema" [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </div>
                  <div class="p-field-checkbox">
                    <p-checkbox binary="true" [ngClass]="{'ng-invalid ng-dirty': submitted && f.pielAlteraciones.value && !f.prurito.value
                        && !f.vesiculas.value && !f.eritema.value && !f.ulceracion.value && !f.botonAceite.value && !f.hiperpigmentacion.value
                        && !f.hipopigmentacion.value && !f.eczema.value && !f.otrosPielAlteraciones.value && !f.fisuras.value
                        && !f.hiperqueratosis.value && !f.petequias.value && !f.onicomicosis.value}"
                      formControlName="fisuras" inputId="fisuras" label="Fisuras" name="fisuras"
                      [ngModel]="examen.fisuras" [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </div>
                  <div class="p-field-checkbox">
                    <p-checkbox binary="true" [ngModel]="examen.hiperqueratosis" [disabled]="examen?.modoVista === 'ver'"
                      [ngClass]="{'ng-invalid ng-dirty': submitted && f.pielAlteraciones.value && !f.prurito.value
                        && !f.vesiculas.value && !f.eritema.value && !f.ulceracion.value && !f.botonAceite.value && !f.hiperpigmentacion.value
                        && !f.hipopigmentacion.value && !f.eczema.value && !f.otrosPielAlteraciones.value && !f.fisuras.value
                        && !f.hiperqueratosis.value && !f.petequias.value && !f.onicomicosis.value}"
                      formControlName="hiperqueratosis" inputId="hiperqueratosis" label="Hiperqueratosis" name="hiperqueratosis">
                    </p-checkbox>
                  </div>
                </div>
                <div class="p-md-3">
                  <div class="p-field-checkbox">
                    <p-checkbox binary="true" [ngClass]="{'ng-invalid ng-dirty': submitted && f.pielAlteraciones.value && !f.prurito.value
                        && !f.vesiculas.value && !f.eritema.value && !f.ulceracion.value && !f.botonAceite.value && !f.hiperpigmentacion.value
                        && !f.hipopigmentacion.value && !f.eczema.value && !f.otrosPielAlteraciones.value && !f.fisuras.value
                        && !f.hiperqueratosis.value && !f.petequias.value && !f.onicomicosis.value}"
                      formControlName="ulceracion" inputId="ulceracion" label="Ulceración" name="ulceracion"
                      [ngModel]="examen.ulceracion" [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </div>
                  <div class="p-field-checkbox">
                    <p-checkbox binary="true" [ngClass]="{'ng-invalid ng-dirty': submitted && f.pielAlteraciones.value && !f.prurito.value
                        && !f.vesiculas.value && !f.eritema.value && !f.ulceracion.value && !f.botonAceite.value && !f.hiperpigmentacion.value
                        && !f.hipopigmentacion.value && !f.eczema.value && !f.otrosPielAlteraciones.value && !f.fisuras.value
                        && !f.hiperqueratosis.value && !f.petequias.value && !f.onicomicosis.value}"
                      formControlName="petequias" inputId="petequias" label="Petequias" name="petequias"
                      [ngModel]="examen.petequias" [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </div>
                  <div class="p-field-checkbox">
                    <p-checkbox binary="true" [ngClass]="{'ng-invalid ng-dirty': submitted && f.pielAlteraciones.value && !f.prurito.value
                        && !f.vesiculas.value && !f.eritema.value && !f.ulceracion.value && !f.botonAceite.value && !f.hiperpigmentacion.value
                        && !f.hipopigmentacion.value && !f.eczema.value && !f.otrosPielAlteraciones.value && !f.fisuras.value
                        && !f.hiperqueratosis.value && !f.petequias.value && !f.onicomicosis.value}"
                      formControlName="onicomicosis" inputId="onicomicosis" label="Onicomicosis" name="onicomicosis"
                      [ngModel]="examen.onicomicosis" [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </div>
                </div>
              </div>
              <app-invalid-from-message *ngIf="submitted && f.pielAlteraciones.value && !f.prurito.value && !f.vesiculas.value && !f.onicomicosis.value
                && !f.eritema.value && !f.ulceracion.value && !f.botonAceite.value && !f.hiperpigmentacion.value && !f.hipopigmentacion.value
                && !f.eczema.value && !f.otrosPielAlteraciones.value && !f.fisuras.value && !f.hiperqueratosis.value && !f.petequias.value">
              </app-invalid-from-message>
            </div>
            <!-- <div class="p-col-12 p-md-6 print_row-full print_dont_break">
              <app-fiel-title label="Descripción (Otros)"></app-fiel-title>
              <p [ngClass]="{'print_show-on-print': f.pielDescripcion.value.length > 0,
                'print_hide-on-print': f.pielDescripcion.value.length < 1}"
                class="print_hidden-area-before-print print_row-full p-field-word-break">
                {{f.pielDescripcion.value}}
              </p>
              <textarea class="print_hide-on-print"
                [ngClass]="{'ng-invalid ng-dirty': submitted && f.pielDescripcion.invalid}" cols="30"
                formControlName="pielDescripcion" id="result" maxlength="1000" name="resul"
                pInputTextarea rows="5" [attr.disabled]="examen?.modoVista === 'ver' ? true : null">
              </textarea>
              <small style="text-align: end;">
                {{ f.pielDescripcion.value.length }}/1000
              </small>
              <app-invalid-from-message *ngIf="submitted && f.pielDescripcion.errors?.required">
              </app-invalid-from-message>
              <app-invalid-from-message *ngIf="f.pielDescripcion.errors?.maxlength"
                message="Solo se permiten {{ f.pielDescripcion.errors.maxlength.requiredLength  }} caracteres">
              </app-invalid-from-message>
            </div> -->
            <!-- <div class="p-field p-col-12 p-md-6 print_row-full">
              <app-fiel-title label="Localización (Otros)"></app-fiel-title>
              <span class="print_edadInputNumber_hide print_show-on-print print_filled_input">
                {{f.pielLocalizacion.value}}
              </span>
              <input [ngClass]="{'ng-invalid ng-dirty': submitted && f.pielLocalizacion.invalid}"
                formControlName="pielLocalizacion" id="pielLocalizacion" name="pielLocalizacion" maxlength="25" pInputText type="text"
                [attr.disabled]="examen?.modoVista === 'ver' ? true : null" />
              <app-invalid-from-message *ngIf="submitted && f.pielLocalizacion.invalid"></app-invalid-from-message>
            </div> -->
            <div class="p-col-12 p-md-6 print_row-full print_dont_break">
              <app-fiel-title label="Observaciones / Localización (Indicar localización o descripción)"></app-fiel-title>
              <p [ngClass]="{'print_show-on-print': f.observacionesPiel.value.length > 0,
                'print_hide-on-print': f.observacionesPiel.value.length < 1}"
                class="print_hidden-area-before-print print_row-full p-field-word-break">
                {{f.observacionesPiel.value}}
              </p>
              <textarea class="print_hide-on-print"
                [ngClass]="{'ng-invalid ng-dirty': submitted && f.observacionesPiel.invalid}" cols="30"
                formControlName="observacionesPiel" id="result" maxlength="1000" name="resul"
                pInputTextarea rows="5" [attr.disabled]="examen?.modoVista === 'ver' ? true : null">
              </textarea>
              <small style="text-align: end;">
                {{ f.observacionesPiel.value.length }}/1000
              </small>
              <app-invalid-from-message *ngIf="submitted && f.observacionesPiel.errors?.required">
              </app-invalid-from-message>
              <app-invalid-from-message *ngIf="f.observacionesPiel.errors?.maxlength"
                message="Solo se permiten {{ f.observacionesPiel.errors.maxlength.requiredLength  }} caracteres">
              </app-invalid-from-message>
            </div>
          </div>
          <!--OJOS-->
          <div *ngIf="configForm.findSection('Ojos')" class="p-col-12 p-md-12">
            <p-divider></p-divider>
            <div class="p-col-12 p-md-12 print_dont_break">
              <app-fiel-title label="Ojos con alteraciones" required="true"></app-fiel-title>
              <div style="display: flex; flex-direction: row; white-space: nowrap" [ngClass]="{'ng-invalid ng-dirty': submitted && f.ojosAlteraciones.invalid }">
                <p-radioButton (onClick)="clickRadioButton('SI', 'OJOS')" name="ojosAlteraciones" [value]="true" formControlName="ojosAlteraciones"
                  label="Si" [ngClass]="{'ng-invalid ng-dirty': submitted && f.ojosAlteraciones.invalid}"
                  [disabled]="examen?.modoVista === 'ver'">
                </p-radioButton>
                <p-radioButton (onClick)="clickRadioButton('NO', 'OJOS')" name="ojosAlteraciones" [value]="false" formControlName="ojosAlteraciones"
                  label="Se examinó y no presentó alteraciones" [ngClass]="{'ng-invalid ng-dirty': submitted && f.ojosAlteraciones.invalid}"
                  [disabled]="examen?.modoVista === 'ver'">
                </p-radioButton>
              </div>
              <app-invalid-from-message *ngIf="submitted && f.ojosAlteraciones.invalid"></app-invalid-from-message>
            </div>
            <div class="p-col-12 p-md-8 print_dont_break">
              <app-fiel-title label="Alteraciones"></app-fiel-title>
              <div class="print_row-half" style="display: flex; white-space: nowrap;">
                <div class="p-md-3">
                  <div class="p-field-checkbox">
                    <p-checkbox binary="true" [ngClass]="{'ng-invalid ng-dirty': submitted && f.ojosAlteraciones.value && !f.irritacionConjuntival.value
                      && !f.alteracionVisionColores.value && !f.cicatricesCornea.value && !f.cataratas.value && !f.nistagmus.value
                      && !f.visionMonocular.value && !f.otrosOjos.value}" formControlName="irritacionConjuntival"
                      inputId="irritacionConjuntival" label="Irritación Conjuntival" name="irritacionConjuntival"
                      [ngModel]="examen.irritacionConjuntival" [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </div>
                  <div class="p-field-checkbox">
                    <p-checkbox binary="true" [ngClass]="{'ng-invalid ng-dirty': submitted && f.ojosAlteraciones.value && !f.irritacionConjuntival.value
                      && !f.alteracionVisionColores.value && !f.cicatricesCornea.value && !f.cataratas.value && !f.nistagmus.value
                      && !f.visionMonocular.value && !f.otrosOjos.value}" formControlName="alteracionVisionColores"
                      inputId="alteracionVisionColores" label="Alt. visión de colores" name="alteracionVisionColores"
                      [ngModel]="examen.alteracionVisionColores" [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </div>
                </div>
                <div class="p-md-3">
                  <div class="p-field-checkbox">
                    <p-checkbox binary="true" [ngClass]="{'ng-invalid ng-dirty': submitted && f.ojosAlteraciones.value && !f.irritacionConjuntival.value
                      && !f.alteracionVisionColores.value && !f.cicatricesCornea.value && !f.cataratas.value && !f.nistagmus.value
                      && !f.visionMonocular.value && !f.otrosOjos.value}"
                      formControlName="cicatricesCornea" inputId="cicatricesCornea" label="Cicatrices de Córnea" name="cicatricesCornea"
                      [ngModel]="examen.cicatricesCornea" [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </div>
                  <div class="p-field-checkbox">
                    <p-checkbox binary="true" [ngClass]="{'ng-invalid ng-dirty': submitted && f.ojosAlteraciones.value && !f.irritacionConjuntival.value
                      && !f.alteracionVisionColores.value && !f.cicatricesCornea.value && !f.cataratas.value && !f.nistagmus.value
                      && !f.visionMonocular.value && !f.otrosOjos.value}"
                      formControlName="cataratas" inputId="cataratas" label="Cataratas" name="cataratas"
                      [ngModel]="examen.cataratas" [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </div>
                </div>
                <div class="p-md-3">
                  <div class="p-field-checkbox">
                    <p-checkbox binary="true" [ngClass]="{'ng-invalid ng-dirty': submitted && f.ojosAlteraciones.value && !f.irritacionConjuntival.value
                      && !f.alteracionVisionColores.value && !f.cicatricesCornea.value && !f.cataratas.value && !f.nistagmus.value
                      && !f.visionMonocular.value && !f.otrosOjos.value}"
                      formControlName="nistagmus" inputId="nistagmus" label="Nistagmus" name="nistagmus"
                      [ngModel]="examen.nistagmus" [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </div>
                  <div class="p-field-checkbox">
                    <p-checkbox (onChange)="clickCheckBox('otrosOjos', $event)" binary="true"
                      [ngClass]="{'ng-invalid ng-dirty': submitted && f.ojosAlteraciones.value && !f.irritacionConjuntival.value
                        && !f.alteracionVisionColores.value && !f.cicatricesCornea.value && !f.cataratas.value && !f.nistagmus.value
                        && !f.visionMonocular.value && !f.otrosOjos.value}"
                      formControlName="otrosOjos" inputId="otrosOjos" label="Otros" name="otrosOjos"
                      [ngModel]="examen.otrosOjos" [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </div>
                </div>
                <div class="p-md-3">
                  <div class="p-field-checkbox">
                    <p-checkbox binary="true" [ngClass]="{'ng-invalid ng-dirty': submitted && f.ojosAlteraciones.value && !f.irritacionConjuntival.value
                        && !f.alteracionVisionColores.value && !f.cicatricesCornea.value && !f.cataratas.value && !f.nistagmus.value
                        && !f.visionMonocular.value && !f.otrosOjos.value}"
                      formControlName="visionMonocular" inputId="visionMonocular" label="Visión monocular" name="visionMonocular"
                      [ngModel]="examen.visionMonocular" [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </div>
                </div>
              </div>
              <app-invalid-from-message *ngIf="submitted && f.ojosAlteraciones.value && !f.irritacionConjuntival.value && !f.alteracionVisionColores.value
                && !f.onicomicosis.value && !f.cicatricesCornea.value && !f.cataratas.value && !f.nistagmus.value && !f.visionMonocular.value
                && !f.otrosOjos.value">
              </app-invalid-from-message>
            </div>
            <div class="p-col-12 p-md-6 print_row-full print_dont_break">
              <app-fiel-title label="Describa"></app-fiel-title>
              <p [ngClass]="{'print_show-on-print': f.descripcionOjos.value.length > 0,
                'print_hide-on-print': f.descripcionOjos.value.length < 1}"
                class="print_hidden-area-before-print print_row-full p-field-word-break">
                {{f.descripcionOjos.value}}
              </p>
              <textarea class="print_hide-on-print"
                [ngClass]="{'ng-invalid ng-dirty': submitted && f.descripcionOjos.invalid}" cols="30"
                formControlName="descripcionOjos" id="result" maxlength="1000" name="resul"
                pInputTextarea rows="5" [attr.disabled]="examen?.modoVista === 'ver' ? true : null">
              </textarea>
              <small style="text-align: end;">
                {{ f.descripcionOjos.value.length }}/1000
              </small>
              <app-invalid-from-message *ngIf="submitted && f.descripcionOjos.errors?.required">
              </app-invalid-from-message>
              <app-invalid-from-message *ngIf="f.descripcionOjos.errors?.maxlength"
                message="Solo se permiten {{ f.descripcionOjos.errors.maxlength.requiredLength  }} caracteres">
              </app-invalid-from-message>
            </div>
            <div class="p-col-12 p-md-12 p-mt-2 p-mb-2">
              <app-fiel-title label="Agudeza Visual" required="true"></app-fiel-title>
            </div>
            <div class="p-col-12 p-md-12 print_dont_break" style="display: flex; flex-wrap: nowrap;">
              <div class="p-col-6 p-md-3">
                <!-- ------------------------------------ojo izq sin correccion---------------------------- -->
                <div *ngIf="configForm.findField('ojoIzquierdoSinCorreccion')" class="p-field p-col-12 p-md-9 print_row-full">
                  <app-fiel-title label="Ojo Izquierdo sin corrección: "></app-fiel-title>
                  <span class="print_edadInputNumber_hide print_show-on-print print_filled_input">
                    {{f.ojoIzquierdoSinCorreccion.value}}
                  </span>
                  <p-inputNumber class="print_hide-on-print" [ngClass]="{'ng-invalid ng-dirty': submitted && f.ojoIzquierdoSinCorreccion.invalid}"
                    formControlName="ojoIzquierdoSinCorreccion" id="ojoIzquierdoSinCorreccion"
                    name="ojoIzquierdoSinCorreccion" maxlength="2" [disabled]="examen?.modoVista === 'ver'">
                  </p-inputNumber>
                  <app-invalid-from-message *ngIf="submitted && f.ojoIzquierdoSinCorreccion.errors?.required"></app-invalid-from-message>
                  <app-invalid-from-message *ngIf="submitted && (f.ojoIzquierdoSinCorreccion.errors?.min || f.ojoIzquierdoSinCorreccion.errors?.max)"
                    message="Solo se permiten valores entre 0 y 10"></app-invalid-from-message>
                </div>
                <!-- ------------------------------------ojo der sin correccion---------------------------- -->
                <div *ngIf="configForm.findField('ojoDerechoSinCorreccion')" class="p-field p-col-12 p-md-9 print_row-full">
                  <app-fiel-title label="Ojo Derecho sin corrección: "></app-fiel-title>
                  <span class="print_edadInputNumber_hide print_show-on-print print_filled_input">
                    {{f.ojoDerechoSinCorreccion.value}}
                  </span>
                  <p-inputNumber class="print_hide-on-print" [ngClass]="{'ng-invalid ng-dirty': submitted && f.ojoDerechoSinCorreccion.invalid}"
                    formControlName="ojoDerechoSinCorreccion" id="ojoDerechoSinCorreccion"
                    name="ojoDerechoSinCorreccion" maxlength="2" [disabled]="examen?.modoVista === 'ver'">
                  </p-inputNumber>
                  <app-invalid-from-message *ngIf="submitted && f.ojoDerechoSinCorreccion.errors?.required"></app-invalid-from-message>
                  <app-invalid-from-message *ngIf="submitted && (f.ojoDerechoSinCorreccion.errors?.min || f.ojoDerechoSinCorreccion.errors?.max)"
                    message="Solo se permiten valores entre 0 y 10"></app-invalid-from-message>
                </div>
              </div>
              <div class="p-col-6 p-md-3">
                <!-- ------------------------------------ojo izq con correccion---------------------------- -->
                <div *ngIf="configForm.findField('ojoIzquierdoConCorreccion')" class="p-field p-col-12 p-md-9 print_row-full">
                  <app-fiel-title label=" Ojo Izquierdo con corrección: "></app-fiel-title>
                  <span class="print_edadInputNumber_hide print_show-on-print print_filled_input">
                    {{f.ojoIzquierdoConCorreccion.value}}
                  </span>
                  <p-inputNumber class="print_hide-on-print" [ngClass]="{'ng-invalid ng-dirty': submitted && f.ojoIzquierdoConCorreccion.invalid}"
                    formControlName="ojoIzquierdoConCorreccion" id="ojoIzquierdoConCorreccion"
                    name="ojoIzquierdoConCorreccion" maxlength="2" [disabled]="examen?.modoVista === 'ver'">
                  </p-inputNumber>
                  <app-invalid-from-message *ngIf="submitted && f.ojoIzquierdoConCorreccion.errors?.required"></app-invalid-from-message>
                  <app-invalid-from-message *ngIf="submitted && (f.ojoIzquierdoConCorreccion.errors?.min || f.ojoIzquierdoConCorreccion.errors?.max)"
                    message="Solo se permiten valores entre 0 y 10"></app-invalid-from-message>
                </div>
                <!-- ------------------------------------ojo der con correccion---------------------------- -->
                <div *ngIf="configForm.findField('ojoDerechoConCorreccion')" class="p-field p-col-12 p-md-9 print_row-full">
                  <app-fiel-title label="Ojo Derecho con corrección: "></app-fiel-title>
                  <span class="print_edadInputNumber_hide print_show-on-print print_filled_input">
                    {{f.ojoDerechoConCorreccion.value}}
                  </span>
                  <p-inputNumber class="print_hide-on-print" [ngClass]="{'ng-invalid ng-dirty': submitted && f.ojoDerechoConCorreccion.invalid}"
                    formControlName="ojoDerechoConCorreccion" id="ojoDerechoConCorreccion"
                    name="ojoDerechoConCorreccion" maxlength="2" [disabled]="examen?.modoVista === 'ver'">
                  </p-inputNumber>
                  <app-invalid-from-message *ngIf="submitted && f.ojoDerechoConCorreccion.errors?.required"></app-invalid-from-message>
                  <app-invalid-from-message *ngIf="submitted && (f.ojoDerechoConCorreccion.errors?.min || f.ojoDerechoConCorreccion.errors?.max)"
                    message="Solo se permiten valores entre 0 y 10"></app-invalid-from-message>
                </div>
              </div>
            </div>
            <div class="p-col-12 p-md-6 print_dont_break">
              <app-fiel-title label="Observaciones"></app-fiel-title>
              <p [ngClass]="{'print_show-on-print': f.observacionOjos.value.length > 0,
                'print_hide-on-print': f.observacionOjos.value.length < 1}"
                class="print_hidden-area-before-print print_row-full p-field-word-break">
                {{f.observacionOjos.value}}
              </p>
              <textarea class="print_hide-on-print"
                [ngClass]="{'ng-invalid ng-dirty': submitted && f.observacionOjos.invalid}" cols="30"
                formControlName="observacionOjos" id="result" maxlength="1000" name="resul"
                pInputTextarea rows="5" [attr.disabled]="examen?.modoVista === 'ver' ? true : null">
              </textarea>
              <small style="text-align: end;">
                {{ f.observacionOjos.value.length }}/1000
              </small>
              <app-invalid-from-message *ngIf="submitted && f.observacionOjos.errors?.required">
              </app-invalid-from-message>
              <app-invalid-from-message *ngIf="f.observacionOjos.errors?.maxlength"
                message="Solo se permiten {{ f.observacionOjos.errors.maxlength.requiredLength  }} caracteres">
              </app-invalid-from-message>
            </div>
          </div>
          <!--CAVIDAD ORAL-->
          <div *ngIf="configForm.findSection('Cavidad Oral')" class="p-col-12 p-md-12">
            <p-divider></p-divider>
            <div class="p-col-12 p-md-12 print_dont_break">
              <app-fiel-title label="Cavidad oral con alteraciones" required="true"></app-fiel-title>
              <div style="display: flex; flex-direction: row; white-space: nowrap" [ngClass]="{'ng-invalid ng-dirty': submitted && f.cavidadOralAlteraciones.invalid }">
                <p-radioButton  name="cavidadOralAlteraciones" [value]="true" formControlName="cavidadOralAlteraciones"
                  label="Si" [ngClass]="{'ng-invalid ng-dirty': submitted && f.cavidadOralAlteraciones.invalid}"
                  [disabled]="examen?.modoVista === 'ver'" (onClick)="clickRadioButton('SI', 'CAVIDADORAL')">
                </p-radioButton>
                <p-radioButton name="cavidadOralAlteraciones" [value]="false" formControlName="cavidadOralAlteraciones"
                  label="Se examinó y no presentó alteraciones" [ngClass]="{'ng-invalid ng-dirty': submitted && f.cavidadOralAlteraciones.invalid}"
                  [disabled]="examen?.modoVista === 'ver'" (onClick)="clickRadioButton('NO', 'CAVIDADORAL')">
                </p-radioButton>
              </div>
              <app-invalid-from-message *ngIf="submitted && f.cavidadOralAlteraciones.invalid"></app-invalid-from-message>
            </div>
            <div class="p-col-12 p-md-6 print_dont_break">
              <app-fiel-title label="Alteraciones"></app-fiel-title>
              <div class="print_row-half" style="display: flex; white-space: nowrap;">
                <div class="p-md-4">
                  <div class="p-field-checkbox">
                    <p-checkbox binary="true" [ngClass]="{'ng-invalid ng-dirty': submitted && f.cavidadOralAlteraciones.value && !f.sangradoEncias.value
                      && !f.faltaPiezaDental.value && !f.ribeteGengival.value && !f.alteracionEsmalteDentario.value && !f.cariesMultiples.value
                      && !f.otrosCavidadOral.value}" formControlName="sangradoEncias"
                      inputId="sangradoEncias" label="Sangrado de Encías" name="sangradoEncias"
                      [ngModel]="examen.sangradoEncias" [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </div>
                  <div class="p-field-checkbox">
                    <p-checkbox binary="true" [ngClass]="{'ng-invalid ng-dirty': submitted && f.cavidadOralAlteraciones.value && !f.sangradoEncias.value
                      && !f.faltaPiezaDental.value && !f.ribeteGengival.value && !f.alteracionEsmalteDentario.value && !f.cariesMultiples.value
                      && !f.otrosCavidadOral.value}" formControlName="faltaPiezaDental"
                      inputId="faltaPiezaDental" label="Falta Pieza Dental" name="faltaPiezaDental"
                      [ngModel]="examen.faltaPiezaDental" [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </div>
                </div>
                <div class="p-md-4">
                  <div class="p-field-checkbox">
                    <p-checkbox binary="true" [ngClass]="{'ng-invalid ng-dirty': submitted && f.cavidadOralAlteraciones.value && !f.sangradoEncias.value
                      && !f.faltaPiezaDental.value && !f.ribeteGengival.value && !f.alteracionEsmalteDentario.value && !f.cariesMultiples.value
                      && !f.otrosCavidadOral.value}"
                      formControlName="ribeteGengival" inputId="ribeteGengival" label="Ribete Gingival" name="ribeteGengival"
                      [ngModel]="examen.ribeteGengival" [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </div>
                  <div class="p-field-checkbox">
                    <p-checkbox binary="true" [ngClass]="{'ng-invalid ng-dirty': submitted && f.cavidadOralAlteraciones.value && !f.sangradoEncias.value
                      && !f.faltaPiezaDental.value && !f.ribeteGengival.value && !f.alteracionEsmalteDentario.value && !f.cariesMultiples.value
                      && !f.otrosCavidadOral.value}" formControlName="alteracionEsmalteDentario" inputId="alteracionEsmalteDentario"
                      label="Alt. Esmalte Dentario" name="alteracionEsmalteDentario"
                      [ngModel]="examen.alteracionEsmalteDentario" [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </div>
                </div>
                <div class="p-md-4">
                  <div class="p-field-checkbox">
                    <p-checkbox binary="true" [ngClass]="{'ng-invalid ng-dirty': submitted && f.cavidadOralAlteraciones.value && !f.sangradoEncias.value
                      && !f.faltaPiezaDental.value && !f.ribeteGengival.value && !f.alteracionEsmalteDentario.value && !f.cariesMultiples.value
                      && !f.otrosCavidadOral.value}"
                      formControlName="cariesMultiples" inputId="cariesMultiples" label="Caries Múltiples" name="cariesMultiples"
                      [ngModel]="examen.cariesMultiples" [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </div>
                  <div class="p-field-checkbox">
                    <p-checkbox (onChange)="clickCheckBox('otrosCavidadOral', $event)" binary="true"
                      [ngClass]="{'ng-invalid ng-dirty': submitted && f.cavidadOralAlteraciones.value && !f.sangradoEncias.value
                        && !f.faltaPiezaDental.value && !f.ribeteGengival.value && !f.alteracionEsmalteDentario.value && !f.cariesMultiples.value
                        && !f.otrosCavidadOral.value}"
                      formControlName="otrosCavidadOral" inputId="otrosCavidadOral" label="Otros" name="otrosCavidadOral"
                      [ngModel]="examen.otrosCavidadOral" [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </div>
                </div>
              </div>
              <app-invalid-from-message *ngIf="submitted && f.cavidadOralAlteraciones.value && !f.sangradoEncias.value && !f.faltaPiezaDental.value
                && !f.onicomicosis.value && !f.ribeteGengival.value && !f.alteracionEsmalteDentario.value && !f.cariesMultiples.value
                && !f.otrosCavidadOral.value">
              </app-invalid-from-message>
            </div>
            <div class="p-col-12 p-md-6 print_dont_break">
              <app-fiel-title label="Describa (Otros)"></app-fiel-title>
              <p [ngClass]="{'print_show-on-print': f.descripcionCavidadOral.value.length > 0,
                'print_hide-on-print': f.descripcionCavidadOral.value.length < 1}"
                class="print_hidden-area-before-print print_row-full p-field-word-break">
                {{f.descripcionCavidadOral.value}}
              </p>
              <textarea class="print_hide-on-print"
                [ngClass]="{'ng-invalid ng-dirty': submitted && f.descripcionCavidadOral.invalid}" cols="30"
                formControlName="descripcionCavidadOral" id="result" maxlength="1000" name="resul"
                pInputTextarea rows="5" [attr.disabled]="examen?.modoVista === 'ver' ? true : null">
              </textarea>
              <small style="text-align: end;">
                {{ f.descripcionCavidadOral.value.length }}/1000
              </small>
              <app-invalid-from-message *ngIf="submitted && f.descripcionCavidadOral.errors?.required">
              </app-invalid-from-message>
              <app-invalid-from-message *ngIf="f.descripcionCavidadOral.errors?.maxlength"
                message="Solo se permiten {{ f.descripcionCavidadOral.errors.maxlength.requiredLength  }} caracteres">
              </app-invalid-from-message>
            </div>
            <div class="p-col-12 p-md-6 print_dont_break">
              <app-fiel-title label="Observaciones"></app-fiel-title>
              <p [ngClass]="{'print_show-on-print': f.observacionesCavidadOral.value.length > 0,
                'print_hide-on-print': f.observacionesCavidadOral.value.length < 1}"
                class="print_hidden-area-before-print print_row-full p-field-word-break">
                {{f.observacionesCavidadOral.value}}
              </p>
              <textarea class="print_hide-on-print"
                [ngClass]="{'ng-invalid ng-dirty': submitted && f.observacionesCavidadOral.invalid}" cols="30"
                formControlName="observacionesCavidadOral" id="result" maxlength="1000" name="resul"
                pInputTextarea rows="5" [attr.disabled]="examen?.modoVista === 'ver' ? true : null">
              </textarea>
              <small style="text-align: end;">
                {{ f.observacionesCavidadOral.value.length }}/1000
              </small>
              <app-invalid-from-message *ngIf="submitted && f.observacionesCavidadOral.errors?.required">
              </app-invalid-from-message>
              <app-invalid-from-message *ngIf="f.observacionesCavidadOral.errors?.maxlength"
                message="Solo se permiten {{ f.observacionesCavidadOral.errors.maxlength.requiredLength  }} caracteres">
              </app-invalid-from-message>
            </div>
          </div>
          <!--NARIZ-->
          <div *ngIf="configForm.findSection('Nariz')" class="p-col-12 p-md-12">
            <p-divider></p-divider>
            <div class="p-col-12 p-md-12 print_dont_break">
              <app-fiel-title label="Nariz con alteraciones" required="true"></app-fiel-title>
              <div style="display: flex; flex-direction: row; white-space: nowrap" [ngClass]="{'ng-invalid ng-dirty': submitted && f.narizAlteraciones.invalid }">
                <p-radioButton  name="narizAlteraciones" [value]="true" formControlName="narizAlteraciones"
                  label="Si" [ngClass]="{'ng-invalid ng-dirty': submitted && f.narizAlteraciones.invalid}"
                  [disabled]="examen?.modoVista === 'ver'" (onClick)="clickRadioButton('SI', 'NARIZ')">
                </p-radioButton>
                <p-radioButton name="narizAlteraciones" [value]="false" formControlName="narizAlteraciones"
                  label="Se examinó y no presentó alteraciones" [ngClass]="{'ng-invalid ng-dirty': submitted && f.narizAlteraciones.invalid}"
                  [disabled]="examen?.modoVista === 'ver'" (onClick)="clickRadioButton('NO', 'NARIZ')">
                </p-radioButton>
              </div>
              <app-invalid-from-message *ngIf="submitted && f.narizAlteraciones.invalid"></app-invalid-from-message>
            </div>
            <div class="p-col-12 p-md-6 print_row-full print_dont_break">
              <app-fiel-title label="Observaciones"></app-fiel-title>
              <p [ngClass]="{'print_show-on-print': f.observacionesNariz.value.length > 0,
                'print_hide-on-print': f.observacionesNariz.value.length < 1}"
                class="print_hidden-area-before-print print_row-full p-field-word-break">
                {{f.observacionesNariz.value}}
              </p>
              <textarea class="print_hide-on-print"
                [ngClass]="{'ng-invalid ng-dirty': submitted && f.observacionesNariz.invalid}" cols="30"
                formControlName="observacionesNariz" id="result" maxlength="1000" name="resul"
                pInputTextarea rows="5" [attr.disabled]="examen?.modoVista === 'ver' ? true : null">
              </textarea>
              <small style="text-align: end;">
                {{ f.observacionesNariz.value.length }}/1000
              </small>
              <app-invalid-from-message *ngIf="submitted && f.observacionesNariz.errors?.required">
              </app-invalid-from-message>
              <app-invalid-from-message *ngIf="f.observacionesNariz.errors?.maxlength"
                message="Solo se permiten {{ f.observacionesNariz.errors.maxlength.requiredLength  }} caracteres">
              </app-invalid-from-message>
            </div>
            <div class="p-col-12 p-md-12 print_dont_break">
              <app-fiel-title label="Rinoscopía / Mucosa nasal con alteraciones" required="true"></app-fiel-title>
              <div style="display: flex; flex-direction: row; white-space: nowrap" [ngClass]="{'ng-invalid ng-dirty': submitted && f.rinoscopiaAlteraciones.invalid }">
                <p-radioButton name="rinoscopiaAlteraciones" [value]="true" formControlName="rinoscopiaAlteraciones"
                  label="Si" [ngClass]="{'ng-invalid ng-dirty': submitted && f.rinoscopiaAlteraciones.invalid}"
                  [disabled]="examen?.modoVista === 'ver'" (onClick)="clickRadioButton('SI', 'RINOSCOPIA')">
                </p-radioButton>
                <p-radioButton name="rinoscopiaAlteraciones" [value]="false" formControlName="rinoscopiaAlteraciones"
                  label="Se examinó y no presentó alteraciones" [ngClass]="{'ng-invalid ng-dirty': submitted && f.rinoscopiaAlteraciones.invalid}"
                  [disabled]="examen?.modoVista === 'ver'" (onClick)="clickRadioButton('NO', 'RINOSCOPIA')">
                </p-radioButton>
              </div>
              <app-invalid-from-message *ngIf="submitted && f.rinoscopiaAlteraciones.invalid"></app-invalid-from-message>
            </div>
            <div class="p-col-12 p-md-12 print_dont_break">
              <app-fiel-title label="Alteraciones"></app-fiel-title>
              <div class="p-field-checkbox-inline" style="display: flex; flex-direction: row;">
                <div class="p-field-checkbox">
                  <p-checkbox binary="true" [ngClass]="{'ng-invalid ng-dirty': submitted && f.rinoscopiaAlteraciones.value
                    && !f.mucosaNasalPalida.value && !f.mucosaNasalUlcerada.value && !f.perforacionTabiqueNasal.value && !f.narizInflamada.value}"
                    formControlName="mucosaNasalPalida" inputId="mucosaNasalPalida" label="M. N. Pálida"
                    name="mucosaNasalPalida" [ngModel]="examen.mucosaNasalPalida" [disabled]="examen?.modoVista === 'ver'">
                  </p-checkbox>
                </div>
                <div class="p-field-checkbox">
                  <p-checkbox binary="true" [ngClass]="{'ng-invalid ng-dirty': submitted && f.rinoscopiaAlteraciones.value
                    && !f.mucosaNasalPalida.value && !f.mucosaNasalUlcerada.value && !f.perforacionTabiqueNasal.value && !f.narizInflamada.value}"
                    formControlName="mucosaNasalUlcerada" inputId="mucosaNasalUlcerada" label="M. N. Ulcerada"
                    name="mucosaNasalUlcerada" [ngModel]="examen.mucosaNasalUlcerada" [disabled]="examen?.modoVista === 'ver'">
                  </p-checkbox>
                </div>
                <div class="p-field-checkbox">
                  <p-checkbox binary="true" [ngClass]="{'ng-invalid ng-dirty': submitted && f.rinoscopiaAlteraciones.value
                    && !f.mucosaNasalPalida.value && !f.mucosaNasalUlcerada.value && !f.perforacionTabiqueNasal.value && !f.narizInflamada.value}"
                    formControlName="perforacionTabiqueNasal" inputId="perforacionTabiqueNasal" label="Perf. Tabique Nasal"
                    name="perforacionTabiqueNasal" [ngModel]="examen.perforacionTabiqueNasal" [disabled]="examen?.modoVista === 'ver'">
                  </p-checkbox>
                </div>
                <div class="p-field-checkbox">
                  <p-checkbox binary="true" [ngClass]="{'ng-invalid ng-dirty': submitted && f.rinoscopiaAlteraciones.value
                    && !f.mucosaNasalPalida.value && !f.mucosaNasalUlcerada.value && !f.perforacionTabiqueNasal.value && !f.narizInflamada.value}"
                    formControlName="narizInflamada" inputId="narizInflamada" label="Inflamada" name="narizInflamada"
                    [ngModel]="examen.narizInflamada" [disabled]="examen?.modoVista === 'ver'">
                  </p-checkbox>
                </div>
              </div>
              <app-invalid-from-message *ngIf="submitted && f.rinoscopiaAlteraciones.value && !f.mucosaNasalPalida.value && !f.mucosaNasalUlcerada.value
                && !f.perforacionTabiqueNasal.value && !f.narizInflamada.value"></app-invalid-from-message>
            </div>
            <div class="p-col-12 p-md-6 print_row-full print_dont_break">
              <app-fiel-title label="Observaciones"></app-fiel-title>
              <p [ngClass]="{'print_show-on-print': f.observacionesRinoscopia.value.length > 0,
                'print_hide-on-print': f.observacionesRinoscopia.value.length < 1}"
                class="print_hidden-area-before-print print_row-full p-field-word-break">
                {{f.observacionesRinoscopia.value}}
              </p>
              <textarea class="print_hide-on-print"
                [ngClass]="{'ng-invalid ng-dirty': submitted && f.observacionesRinoscopia.invalid}" cols="30"
                formControlName="observacionesRinoscopia" id="result" maxlength="1000" name="resul"
                pInputTextarea rows="5" [attr.disabled]="examen?.modoVista === 'ver' ? true : null">
              </textarea>
              <small style="text-align: end;">
                {{ f.observacionesRinoscopia.value.length }}/1000
              </small>
              <app-invalid-from-message *ngIf="submitted && f.observacionesRinoscopia.errors?.required">
              </app-invalid-from-message>
              <app-invalid-from-message *ngIf="f.observacionesRinoscopia.errors?.maxlength"
                message="Solo se permiten {{ f.observacionesRinoscopia.errors.maxlength.requiredLength  }} caracteres">
              </app-invalid-from-message>
            </div>
          </div>
          <!--CUELLO-->
          <div *ngIf="configForm.findSection('Cuello')" class="p-col-12 p-md-12">
            <p-divider></p-divider>
            <div class="p-col-12 p-md-12 print_dont_break">
              <app-fiel-title label="Cuello con alteraciones" required="true"></app-fiel-title>
              <div style="display: flex; flex-direction: row; white-space: nowrap" [ngClass]="{'ng-invalid ng-dirty': submitted && f.cuelloAlteraciones.invalid }">
                <p-radioButton name="cuelloAlteraciones" [value]="true" formControlName="cuelloAlteraciones"
                  label="Si" [ngClass]="{'ng-invalid ng-dirty': submitted && f.cuelloAlteraciones.invalid}"
                  [disabled]="examen?.modoVista === 'ver'" (onClick)="clickRadioButton('SI', 'CUELLO')">
                </p-radioButton>
                <p-radioButton name="cuelloAlteraciones" [value]="false" formControlName="cuelloAlteraciones"
                  label="Se examinó y no presentó alteraciones" [ngClass]="{'ng-invalid ng-dirty': submitted && f.cuelloAlteraciones.invalid}"
                  [disabled]="examen?.modoVista === 'ver'" (onClick)="clickRadioButton('NO', 'CUELLO')">
                </p-radioButton>
              </div>
              <app-invalid-from-message *ngIf="submitted && f.cuelloAlteraciones.invalid"></app-invalid-from-message>
            </div>
            <div class="p-col-12 p-md-6 print_dont_break">
              <app-fiel-title label="Observaciones alteración"></app-fiel-title>
              <p [ngClass]="{'print_show-on-print': f.observacionesCuelloAlteraciones.value.length > 0,
                'print_hide-on-print': f.observacionesCuelloAlteraciones.value.length < 1}"
                class="print_hidden-area-before-print print_row-full p-field-word-break">
                {{f.observacionesCuelloAlteraciones.value}}
              </p>
              <textarea class="print_hide-on-print"
                [ngClass]="{'ng-invalid ng-dirty': submitted && f.observacionesCuelloAlteraciones.invalid}" cols="30"
                formControlName="observacionesCuelloAlteraciones" id="result" maxlength="1000" name="resul"
                pInputTextarea rows="5" [attr.disabled]="examen?.modoVista === 'ver' ? true : null">
              </textarea>
              <small style="text-align: end;">
                {{ f.observacionesCuelloAlteraciones.value.length }}/1000
              </small>
              <app-invalid-from-message *ngIf="submitted && f.observacionesCuelloAlteraciones.errors?.required">
              </app-invalid-from-message>
              <app-invalid-from-message *ngIf="f.observacionesCuelloAlteraciones.errors?.maxlength"
                message="Solo se permiten {{ f.observacionesCuelloAlteraciones.errors.maxlength.requiredLength  }} caracteres">
              </app-invalid-from-message>
            </div>
            <div class="p-col-12 p-md-6 print_dont_break">
              <app-fiel-title label="Observaciones"></app-fiel-title>
              <p [ngClass]="{'print_show-on-print': f.observacionesCuello.value.length > 0,
                'print_hide-on-print': f.observacionesCuello.value.length < 1}"
                class="print_hidden-area-before-print print_row-full p-field-word-break">
                {{f.observacionesCuello.value}}
              </p>
              <textarea class="print_hide-on-print"
                [ngClass]="{'ng-invalid ng-dirty': submitted && f.observacionesCuello.invalid}" cols="30"
                formControlName="observacionesCuello" id="result" maxlength="1000" name="resul"
                pInputTextarea rows="5" [attr.disabled]="examen?.modoVista === 'ver' ? true : null">
              </textarea>
              <small style="text-align: end;">
                {{ f.observacionesCuello.value.length }}/1000
              </small>
              <app-invalid-from-message *ngIf="submitted && f.observacionesCuello.errors?.required">
              </app-invalid-from-message>
              <app-invalid-from-message *ngIf="f.observacionesCuello.errors?.maxlength"
                message="Solo se permiten {{ f.observacionesCuello.errors.maxlength.requiredLength  }} caracteres">
              </app-invalid-from-message>
            </div>
          </div>
          <!--TORAX-->
          <div *ngIf="configForm.findSection('Tórax')" class="p-col-12 p-md-12">
            <p-divider></p-divider>
            <div class="p-col-12 p-md-12 print_dont_break">
              <app-fiel-title label="Tórax con alteraciones" required="true"></app-fiel-title>
              <div style="display: flex; flex-direction: row; white-space: nowrap" [ngClass]="{'ng-invalid ng-dirty': submitted && f.toraxAlteraciones.invalid }">
                <p-radioButton name="toraxAlteraciones" [value]="true" formControlName="toraxAlteraciones"
                  label="Si" [ngClass]="{'ng-invalid ng-dirty': submitted && f.toraxAlteraciones.invalid}"
                  [disabled]="examen?.modoVista === 'ver'" (onClick)="clickRadioButton('SI', 'TORAX')">
                </p-radioButton>
                <p-radioButton name="toraxAlteraciones" [value]="false" formControlName="toraxAlteraciones"
                  label="Se examinó y no presentó alteraciones" [ngClass]="{'ng-invalid ng-dirty': submitted && f.toraxAlteraciones.invalid}"
                  [disabled]="examen?.modoVista === 'ver'" (onClick)="clickRadioButton('NO', 'TORAX')">
                </p-radioButton>
              </div>
              <app-invalid-from-message *ngIf="submitted && f.toraxAlteraciones.invalid"></app-invalid-from-message>
            </div>
            <div class="p-col-12 p-md-6 print_dont_break">
              <app-fiel-title label="Alteraciones"></app-fiel-title>
              <div class="print_row-half" style="display: flex; white-space: nowrap;">
                <div class="p-md-4">
                  <div class="p-field-checkbox">
                    <p-checkbox binary="true" [ngClass]="{'ng-invalid ng-dirty': submitted && f.toraxAlteraciones.value && !f.roncus.value
                      && !f.crepitantes.value && !f.sibilancias.value && !f.subCrepitantes.value && !f.disnea.value && !f.deformacionesTorax.value}" formControlName="roncus"
                      inputId="roncus" label="Roncus" name="roncus"
                      [ngModel]="examen.roncus" [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </div>
                  <div class="p-field-checkbox">
                    <p-checkbox binary="true" [ngClass]="{'ng-invalid ng-dirty': submitted && f.toraxAlteraciones.value && !f.roncus.value
                      && !f.crepitantes.value && !f.sibilancias.value && !f.subCrepitantes.value && !f.disnea.value && !f.deformacionesTorax.value}"
                      formControlName="crepitantes" inputId="crepitantes" label="Rales Crepitantes"
                      name="crepitantes" [ngModel]="examen.crepitantes" [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </div>
                </div>
                <div class="p-md-4">
                  <div class="p-field-checkbox">
                    <p-checkbox binary="true" [ngClass]="{'ng-invalid ng-dirty': submitted && f.toraxAlteraciones.value && !f.roncus.value
                      && !f.crepitantes.value && !f.sibilancias.value && !f.subCrepitantes.value && !f.disnea.value && !f.deformacionesTorax.value}"
                      formControlName="sibilancias" inputId="sibilancias" label="Sibilancias" name="sibilancias"
                      [ngModel]="examen.sibilancias" [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </div>
                  <div class="p-field-checkbox">
                    <p-checkbox binary="true" [ngClass]="{'ng-invalid ng-dirty': submitted && f.toraxAlteraciones.value && !f.roncus.value
                      && !f.crepitantes.value && !f.sibilancias.value && !f.subCrepitantes.value && !f.disnea.value && !f.deformacionesTorax.value}"
                      formControlName="subCrepitantes" inputId="subCrepitantes" label="Rales Subcrepitantes" name="subCrepitantes"
                      [ngModel]="examen.subCrepitantes" [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </div>
                </div>
                <div class="p-md-4">
                  <div class="p-field-checkbox">
                    <p-checkbox binary="true" [ngClass]="{'ng-invalid ng-dirty': submitted && f.toraxAlteraciones.value && !f.roncus.value
                      && !f.crepitantes.value && !f.sibilancias.value && !f.subCrepitantes.value && !f.disnea.value && !f.deformacionesTorax.value}"
                      formControlName="disnea" inputId="disnea" label="Disnea" name="disnea"
                      [ngModel]="examen.disnea" [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </div>
                  <div class="p-field-checkbox">
                    <p-checkbox binary="true" [ngClass]="{'ng-invalid ng-dirty': submitted && f.toraxAlteraciones.value && !f.roncus.value
                      && !f.crepitantes.value && !f.sibilancias.value && !f.subCrepitantes.value && !f.disnea.value && !f.deformacionesTorax.value}"
                      formControlName="deformacionesTorax" inputId="deformacionesTorax" label="Deformaciones" name="deformacionesTorax"
                      [ngModel]="examen.deformacionesTorax" [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </div>
                </div>
              </div>
              <app-invalid-from-message *ngIf="submitted && f.toraxAlteraciones.value && !f.roncus.value && !f.crepitantes.value
                && !f.sibilancias.value && !f.subCrepitantes.value && !f.disnea.value && !f.deformacionesTorax.value">
              </app-invalid-from-message>
            </div>
            <div class="p-field p-col-12 p-md-3 print_dont_break">
              <app-fiel-title label="Frecuencia Respiratoria" required="true"></app-fiel-title>
              <span class="print_edadInputNumber_hide print_show-on-print print_filled_input">
                {{f.frecuenciaRespiratoria.value}}
              </span>
              <p-inputNumber class="print_hide-on-print" [ngClass]="{'ng-invalid ng-dirty': submitted && f.frecuenciaRespiratoria.invalid}"
                formControlName="frecuenciaRespiratoria" id="frecuenciaRespiratoria" maxlength="3"
                name="frecuenciaRespiratoria" [disabled]="examen?.modoVista === 'ver'">
              </p-inputNumber>
              <app-invalid-from-message *ngIf="submitted && f.frecuenciaRespiratoria.errors?.required"></app-invalid-from-message>
              <app-invalid-from-message *ngIf="submitted && (f.frecuenciaRespiratoria.errors?.min || f.frecuenciaRespiratoria.errors?.max)"
                message="Solo se permiten valores entre 0 y 200"></app-invalid-from-message>
            </div>
            <div class="p-col-12 p-md-6 print_row-full print_dont_break">
              <app-fiel-title label="Observaciones"></app-fiel-title>
              <p [ngClass]="{'print_show-on-print': f.observacionesTorax.value.length > 0,
                'print_hide-on-print': f.observacionesTorax.value.length < 1}"
                class="print_hidden-area-before-print print_row-full p-field-word-break">
                {{f.observacionesTorax.value}}
              </p>
              <textarea class="print_hide-on-print"
                [ngClass]="{'ng-invalid ng-dirty': submitted && f.observacionesTorax.invalid}" cols="30"
                formControlName="observacionesTorax" id="result" maxlength="1000" name="resul"
                pInputTextarea rows="5" [attr.disabled]="examen?.modoVista === 'ver' ? true : null">
              </textarea>
              <small style="text-align: end;">
                {{ f.observacionesTorax.value.length }}/1000
              </small>
              <app-invalid-from-message *ngIf="submitted && f.observacionesTorax.errors?.required">
              </app-invalid-from-message>
              <app-invalid-from-message *ngIf="f.observacionesTorax.errors?.maxlength"
                message="Solo se permiten {{ f.observacionesTorax.errors.maxlength.requiredLength  }} caracteres">
              </app-invalid-from-message>
            </div>
          </div>
          <!--CARDIOCIRCULATORIO-->
          <div *ngIf="configForm.findSection('Cardiocirculatorio')" class="p-col-12 p-md-12">
            <p-divider></p-divider>
            <div class="p-col-12 p-md-12 print_dont_break">
              <app-fiel-title label="Cardiocirculatorio con alteraciones" required="true"></app-fiel-title>
              <div style="display: flex; flex-direction: row; white-space: nowrap" [ngClass]="{'ng-invalid ng-dirty': submitted && f.cardiocirculatorioAlteraciones.invalid }">
                <p-radioButton (onClick)="clickRadioButton('SI', 'CARDIOCIRCULATORIO')" name="cardiocirculatorioAlteraciones" [value]="true"
                  formControlName="cardiocirculatorioAlteraciones" label="Si" [disabled]="examen?.modoVista === 'ver'"
                  [ngClass]="{'ng-invalid ng-dirty': submitted && f.cardiocirculatorioAlteraciones.invalid}">
                </p-radioButton>
                <p-radioButton (onClick)="clickRadioButton('NO', 'CARDIOCIRCULATORIO')" name="cardiocirculatorioAlteraciones" [value]="false"
                  formControlName="cardiocirculatorioAlteraciones" label="Se examinó y no presentó alteraciones"
                  [ngClass]="{'ng-invalid ng-dirty': submitted && f.cardiocirculatorioAlteraciones.invalid}"
                  [disabled]="examen?.modoVista === 'ver'">
                </p-radioButton>
              </div>
              <app-invalid-from-message *ngIf="submitted && f.cardiocirculatorioAlteraciones.invalid"></app-invalid-from-message>
            </div>
            <div class="p-col-12 p-md-12 print_dont_break">
              <app-fiel-title label="Alteraciones"></app-fiel-title>
              <div class="p-field-checkbox-inline" style="display: flex; flex-direction: row;">
                <div class="p-field-checkbox">
                  <p-checkbox binary="true" [ngClass]="{'ng-invalid ng-dirty': submitted && f.cardiocirculatorioAlteraciones.value
                      && !f.arritmia.value && !f.soplos.value && !f.varices.value}"
                    formControlName="arritmia" inputId="arritmia" label="Arritmia" name="arritmia"
                    [ngModel]="examen.arritmia" [disabled]="examen?.modoVista === 'ver'">
                  </p-checkbox>
                </div>
                <div class="p-field-checkbox">
                  <p-checkbox binary="true" [ngClass]="{'ng-invalid ng-dirty': submitted && f.cardiocirculatorioAlteraciones.value
                      && !f.arritmia.value && !f.soplos.value && !f.varices.value}"
                    formControlName="soplos" inputId="soplos" label="Soplos" name="soplos"
                    [ngModel]="examen.soplos" [disabled]="examen?.modoVista === 'ver'">
                  </p-checkbox>
                </div>
                <div class="p-field-checkbox">
                  <p-checkbox (onChange)="clickCheckBox('varices', $event)" binary="true"
                    [ngClass]="{'ng-invalid ng-dirty': submitted && f.cardiocirculatorioAlteraciones.value && !f.arritmia.value
                      && !f.soplos.value && !f.varices.value}"
                    formControlName="varices" inputId="varices" label="Várices" name="varices"
                    [ngModel]="examen.varices" [disabled]="examen?.modoVista === 'ver'">
                  </p-checkbox>
                </div>
              </div>
              <app-invalid-from-message *ngIf="submitted && f.cardiocirculatorioAlteraciones.value && !f.arritmia.value
                && !f.soplos.value && !f.varices.value"></app-invalid-from-message>
            </div>
            <div class="p-col-12 p-md-6">
              <table class="p-datatable-solid" [ngClass]="{'enabled': enableTableVarices}">
                <thead>
                  <tr>
                    <th class="no-border-cell"></th>
                    <th class="no-border-cell"></th>
                    <th>M.izq</th>
                    <th>M.der</th>
                    <th>Bilateral</th>
                    <th>A</th>
                    <th>S</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>C0</td>
                    <td>Sin signo visible o palpable de enfermedad venosa</td>
                    <td>
                      <p-checkbox class="tableVarices" (onChange)="clickTableVarices('c0mizq', $event.checked)" binary="true"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && f.varices.value && cuadroVaricesInvalid}"
                        formControlName="c0mizq" inputId="c0mizq" label="" name="c0mizq"
                        [ngModel]="examen.c0mizq" [disabled]="examen?.modoVista === 'ver'">
                      </p-checkbox>
                    </td>
                    <td>
                      <p-checkbox class="tableVarices" (onChange)="clickTableVarices('c0mder', $event.checked)" binary="true"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && f.varices.value && cuadroVaricesInvalid}"
                        formControlName="c0mder" inputId="c0mder" label="" name="c0mder"
                        [ngModel]="examen.c0mder" [disabled]="examen?.modoVista === 'ver'">
                      </p-checkbox>
                    </td>
                    <td>
                      <p-checkbox class="tableVarices" (onChange)="clickTableVarices('c0bilateral', $event.checked)" binary="true"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && f.varices.value && cuadroVaricesInvalid}"
                        formControlName="c0bilateral" inputId="c0bilateral" label="" name="c0bilateral"
                        [ngModel]="examen.c0bilateral" [disabled]="examen?.modoVista === 'ver'">
                      </p-checkbox>
                    </td>
                    <td>
                      <p-checkbox class="tableVarices" (onChange)="clickTableVarices('c0asintomatico', $event.checked)" binary="true"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && f.varices.value && cuadroVaricesInvalid}"
                        formControlName="c0asintomatico" inputId="c0asintomatico" label="" name="c0asintomatico"
                        [ngModel]="examen.c0asintomatico" [disabled]="examen?.modoVista === 'ver'">
                      </p-checkbox>
                    </td>
                    <td>
                      <p-checkbox class="tableVarices" (onChange)="clickTableVarices('c0sintomatico', $event.checked)" binary="true"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && f.varices.value && cuadroVaricesInvalid}"
                        formControlName="c0sintomatico" inputId="c0sintomatico" label="" name="c0sintomatico"
                        [ngModel]="examen.c0sintomatico" [disabled]="examen?.modoVista === 'ver'">
                      </p-checkbox>
                    </td>
                  </tr>
                  <tr>
                    <td>C1</td>
                    <td>Telangiectasias o venas reticulares</td>
                    <td>
                      <p-checkbox class="tableVarices" (onChange)="clickTableVarices('c1mizq', $event.checked)" binary="true"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && f.varices.value && cuadroVaricesInvalid}"
                        formControlName="c1mizq" inputId="c1mizq" label="" name="c1mizq"
                        [ngModel]="examen.c1mizq" [disabled]="examen?.modoVista === 'ver'">
                      </p-checkbox>
                    </td>
                    <td>
                      <p-checkbox class="tableVarices" (onChange)="clickTableVarices('c1mder', $event.checked)" binary="true"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && f.varices.value && cuadroVaricesInvalid}"
                        formControlName="c1mder" inputId="c1mder" label="" name="c1mder"
                        [ngModel]="examen.c1mder" [disabled]="examen?.modoVista === 'ver'">
                      </p-checkbox>
                    </td>
                    <td>
                      <p-checkbox class="tableVarices" (onChange)="clickTableVarices('c1bilateral', $event.checked)" binary="true"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && f.varices.value && cuadroVaricesInvalid}"
                        formControlName="c1bilateral" inputId="c1bilateral" label="" name="c1bilateral"
                        [ngModel]="examen.c1bilateral" [disabled]="examen?.modoVista === 'ver'">
                      </p-checkbox>
                    </td>
                    <td>
                      <p-checkbox class="tableVarices" (onChange)="clickTableVarices('c1asintomatico', $event.checked)" binary="true"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && f.varices.value && cuadroVaricesInvalid}"
                        formControlName="c1asintomatico" inputId="c1asintomatico" label="" name="c1asintomatico"
                        [ngModel]="examen.c1asintomatico" [disabled]="examen?.modoVista === 'ver'">
                      </p-checkbox>
                    </td>
                    <td>
                      <p-checkbox class="tableVarices" (onChange)="clickTableVarices('c1sintomatico', $event.checked)" binary="true"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && f.varices.value && cuadroVaricesInvalid}"
                        formControlName="c1sintomatico" inputId="c1sintomatico" label="" name="c1sintomatico"
                        [ngModel]="examen.c1sintomatico" [disabled]="examen?.modoVista === 'ver'">
                      </p-checkbox>
                    </td>
                  </tr>
                  <tr>
                    <td>C2</td>
                    <td>Venas varicosas, Se diferencian de las venas reticulares en que su diámetro es igual o superior a 3 mm.</td>
                    <td>
                      <p-checkbox class="tableVarices" (onChange)="clickTableVarices('c2mizq', $event.checked)" binary="true"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && f.varices.value && cuadroVaricesInvalid}"
                        formControlName="c2mizq" inputId="c2mizq" label="" name="c2mizq"
                        [ngModel]="examen.c2mizq" [disabled]="examen?.modoVista === 'ver'">
                      </p-checkbox>
                    </td>
                    <td>
                      <p-checkbox class="tableVarices" (onChange)="clickTableVarices('c2mder', $event.checked)" binary="true"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && f.varices.value && cuadroVaricesInvalid}"
                        formControlName="c2mder" inputId="c2mder" label="" name="c2mder"
                        [ngModel]="examen.c2mder" [disabled]="examen?.modoVista === 'ver'">
                      </p-checkbox>
                    </td>
                    <td>
                      <p-checkbox class="tableVarices" (onChange)="clickTableVarices('c2bilateral', $event.checked)" binary="true"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && f.varices.value && cuadroVaricesInvalid}"
                        formControlName="c2bilateral" inputId="c2bilateral" label="" name="c2bilateral"
                        [ngModel]="examen.c2bilateral" [disabled]="examen?.modoVista === 'ver'">
                      </p-checkbox>
                    </td>
                    <td>
                      <p-checkbox class="tableVarices" (onChange)="clickTableVarices('c2asintomatico', $event.checked)" binary="true"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && f.varices.value && cuadroVaricesInvalid}"
                        formControlName="c2asintomatico" inputId="c2asintomatico" label="" name="c2asintomatico"
                        [ngModel]="examen.c2asintomatico" [disabled]="examen?.modoVista === 'ver'">
                      </p-checkbox>
                    </td>
                    <td>
                      <p-checkbox class="tableVarices" (onChange)="clickTableVarices('c2sintomatico', $event.checked)" binary="true"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && f.varices.value && cuadroVaricesInvalid}"
                        formControlName="c2sintomatico" inputId="c2sintomatico" label="" name="c2sintomatico"
                        [ngModel]="examen.c2sintomatico" [disabled]="examen?.modoVista === 'ver'">
                      </p-checkbox>
                    </td>
                  </tr>
                  <tr>
                    <td>C3</td>
                    <td>Edema</td>
                    <td>
                      <p-checkbox class="tableVarices" (onChange)="clickTableVarices('c3mizq', $event.checked)" binary="true"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && f.varices.value && cuadroVaricesInvalid}"
                        formControlName="c3mizq" inputId="c3mizq" label="" name="c3mizq"
                        [ngModel]="examen.c3mizq" [disabled]="examen?.modoVista === 'ver'">
                      </p-checkbox>
                    </td>
                    <td>
                      <p-checkbox class="tableVarices" (onChange)="clickTableVarices('c3mder', $event.checked)" binary="true"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && f.varices.value && cuadroVaricesInvalid}"
                        formControlName="c3mder" inputId="c3mder" label="" name="c3mder"
                        [ngModel]="examen.c3mder" [disabled]="examen?.modoVista === 'ver'">
                      </p-checkbox>
                    </td>
                    <td>
                      <p-checkbox class="tableVarices" (onChange)="clickTableVarices('c3bilateral', $event.checked)" binary="true"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && f.varices.value && cuadroVaricesInvalid}"
                        formControlName="c3bilateral" inputId="c3bilateral" label="" name="c3bilateral"
                        [ngModel]="examen.c3bilateral" [disabled]="examen?.modoVista === 'ver'">
                      </p-checkbox>
                    </td>
                    <td>
                      <p-checkbox class="tableVarices" (onChange)="clickTableVarices('c3asintomatico', $event.checked)" binary="true"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && f.varices.value && cuadroVaricesInvalid}"
                        formControlName="c3asintomatico" inputId="c3asintomatico" label="" name="c3asintomatico"
                        [ngModel]="examen.c3asintomatico" [disabled]="examen?.modoVista === 'ver'">
                      </p-checkbox>
                    </td>
                    <td>
                      <p-checkbox class="tableVarices" (onChange)="clickTableVarices('c3sintomatico', $event.checked)" binary="true"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && f.varices.value && cuadroVaricesInvalid}"
                        formControlName="c3sintomatico" inputId="c3sintomatico" label="" name="c3sintomatico"
                        [ngModel]="examen.c3sintomatico" [disabled]="examen?.modoVista === 'ver'">
                      </p-checkbox>
                    </td>
                  </tr>
                  <tr>
                    <td>C4a</td>
                    <td>Enfermedad venosa crónica, c/pigmentación y/o eczema venoso</td>
                    <td>
                      <p-checkbox class="tableVarices" (onChange)="clickTableVarices('c4amizq', $event.checked)" binary="true"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && f.varices.value && cuadroVaricesInvalid}"
                        formControlName="c4amizq" inputId="c4amizq" label="" name="c4amizq"
                        [ngModel]="examen.c4amizq" [disabled]="examen?.modoVista === 'ver'">
                      </p-checkbox>
                    </td>
                    <td>
                      <p-checkbox class="tableVarices" (onChange)="clickTableVarices('c4amder', $event.checked)" binary="true"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && f.varices.value && cuadroVaricesInvalid}"
                        formControlName="c4amder" inputId="c4amder" label="" name="c4amder"
                        [ngModel]="examen.c4amder" [disabled]="examen?.modoVista === 'ver'">
                      </p-checkbox>
                    </td>
                    <td>
                      <p-checkbox class="tableVarices" (onChange)="clickTableVarices('c4abilateral', $event.checked)" binary="true"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && f.varices.value && cuadroVaricesInvalid}"
                        formControlName="c4abilateral" inputId="c4abilateral" label="" name="c4abilateral"
                        [ngModel]="examen.c4abilateral" [disabled]="examen?.modoVista === 'ver'">
                      </p-checkbox>
                    </td>
                    <td>
                      <p-checkbox class="tableVarices" (onChange)="clickTableVarices('c4aasintomatico', $event.checked)" binary="true"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && f.varices.value && cuadroVaricesInvalid}"
                        formControlName="c4aasintomatico" inputId="c4aasintomatico" label="" name="c4aasintomatico"
                        [ngModel]="examen.c4aasintomatico" [disabled]="examen?.modoVista === 'ver'">
                      </p-checkbox>
                    </td>
                    <td>
                      <p-checkbox class="tableVarices" (onChange)="clickTableVarices('c4asintomatico', $event.checked)" binary="true"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && f.varices.value && cuadroVaricesInvalid}"
                        formControlName="c4asintomatico" inputId="c4asintomatico" label="" name="c4asintomatico"
                        [ngModel]="examen.c4asintomatico" [disabled]="examen?.modoVista === 'ver'">
                      </p-checkbox>
                    </td>
                  </tr>
                  <tr>
                    <td>C4b</td>
                    <td>Enfermedad venosa crónica, con celulitis indurada y/o atrofia blanca</td>
                    <td>
                      <p-checkbox class="tableVarices" (onChange)="clickTableVarices('c4bmizq', $event.checked)" binary="true"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && f.varices.value && cuadroVaricesInvalid}"
                        formControlName="c4bmizq" inputId="c4bmizq" label="" name="c4bmizq"
                        [ngModel]="examen.c4bmizq" [disabled]="examen?.modoVista === 'ver'">
                      </p-checkbox>
                    </td>
                    <td>
                      <p-checkbox class="tableVarices" (onChange)="clickTableVarices('c4bmder', $event.checked)" binary="true"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && f.varices.value && cuadroVaricesInvalid}"
                        formControlName="c4bmder" inputId="c4bmder" label="" name="c4bmder"
                        [ngModel]="examen.c4bmder" [disabled]="examen?.modoVista === 'ver'">
                      </p-checkbox>
                    </td>
                    <td>
                      <p-checkbox class="tableVarices" (onChange)="clickTableVarices('c4bbilateral', $event.checked)" binary="true"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && f.varices.value && cuadroVaricesInvalid}"
                        formControlName="c4bbilateral" inputId="c4bbilateral" label="" name="c4bbilateral"
                        [ngModel]="examen.c4bbilateral" [disabled]="examen?.modoVista === 'ver'">
                      </p-checkbox>
                    </td>
                    <td>
                      <p-checkbox class="tableVarices" (onChange)="clickTableVarices('c4basintomatico', $event.checked)" binary="true"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && f.varices.value && cuadroVaricesInvalid}"
                        formControlName="c4basintomatico" inputId="c4basintomatico" label="" name="c4basintomatico"
                        [ngModel]="examen.c4basintomatico" [disabled]="examen?.modoVista === 'ver'">
                      </p-checkbox>
                    </td>
                    <td>
                      <p-checkbox class="tableVarices" (onChange)="clickTableVarices('c4bsintomatico', $event.checked)" binary="true"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && f.varices.value && cuadroVaricesInvalid}"
                        formControlName="c4bsintomatico" inputId="c4bsintomatico" label="" name="c4bsintomatico"
                        [ngModel]="examen.c4bsintomatico" [disabled]="examen?.modoVista === 'ver'">
                      </p-checkbox>
                    </td>
                  </tr>
                  <tr>
                    <td>C5</td>
                    <td>Úlcera cicatrizada</td>
                    <td>
                      <p-checkbox class="tableVarices" (onChange)="clickTableVarices('c5mizq', $event.checked)" binary="true"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && f.varices.value && cuadroVaricesInvalid}"
                        formControlName="c5mizq" inputId="c5mizq" label="" name="c5mizq"
                        [ngModel]="examen.c5mizq" [disabled]="examen?.modoVista === 'ver'">
                      </p-checkbox>
                    </td>
                    <td>
                      <p-checkbox class="tableVarices" (onChange)="clickTableVarices('c5mder', $event.checked)" binary="true"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && f.varices.value && cuadroVaricesInvalid}"
                        formControlName="c5mder" inputId="c5mder" label="" name="c5mder"
                        [ngModel]="examen.c5mder" [disabled]="examen?.modoVista === 'ver'">
                      </p-checkbox>
                    </td>
                    <td>
                      <p-checkbox class="tableVarices" (onChange)="clickTableVarices('c5bilateral', $event.checked)" binary="true"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && f.varices.value && cuadroVaricesInvalid}"
                        formControlName="c5bilateral" inputId="c5bilateral" label="" name="c5bilateral"
                        [ngModel]="examen.c5bilateral" [disabled]="examen?.modoVista === 'ver'">
                      </p-checkbox>
                    </td>
                    <td>
                      <p-checkbox class="tableVarices" (onChange)="clickTableVarices('c5asintomatico', $event.checked)" binary="true"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && f.varices.value && cuadroVaricesInvalid}"
                        formControlName="c5asintomatico" inputId="c5asintomatico" label="" name="c5asintomatico"
                        [ngModel]="examen.c5asintomatico" [disabled]="examen?.modoVista === 'ver'">
                      </p-checkbox>
                    </td>
                    <td>
                      <p-checkbox class="tableVarices" (onChange)="clickTableVarices('c5sintomatico', $event.checked)" binary="true"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && f.varices.value && cuadroVaricesInvalid}"
                        formControlName="c5sintomatico" inputId="c5sintomatico" label="" name="c5sintomatico"
                        [ngModel]="examen.c5sintomatico" [disabled]="examen?.modoVista === 'ver'">
                      </p-checkbox>
                    </td>
                  </tr>
                  <tr>
                    <td>C6</td>
                    <td>Úlcera no cicatrizada</td>
                    <td>
                      <p-checkbox class="tableVarices" (onChange)="clickTableVarices('c6mizq', $event.checked)" binary="true"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && f.varices.value && cuadroVaricesInvalid}"
                        formControlName="c6mizq" inputId="c6mizq" label="" name="c6mizq"
                        [ngModel]="examen.c6mizq" [disabled]="examen?.modoVista === 'ver'">
                      </p-checkbox>
                    </td>
                    <td>
                      <p-checkbox class="tableVarices" (onChange)="clickTableVarices('c6mder', $event.checked)" binary="true"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && f.varices.value && cuadroVaricesInvalid}"
                        formControlName="c6mder" inputId="c6mder" label="" name="c6mder"
                        [ngModel]="examen.c6mder" [disabled]="examen?.modoVista === 'ver'">
                      </p-checkbox>
                    </td>
                    <td>
                      <p-checkbox class="tableVarices" (onChange)="clickTableVarices('c6bilateral', $event.checked)" binary="true"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && f.varices.value && cuadroVaricesInvalid}"
                        formControlName="c6bilateral" inputId="c6bilateral" label="" name="c6bilateral"
                        [ngModel]="examen.c6bilateral" [disabled]="examen?.modoVista === 'ver'">
                      </p-checkbox>
                    </td>
                    <td>
                      <p-checkbox class="tableVarices" (onChange)="clickTableVarices('c6asintomatico', $event.checked)" binary="true"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && f.varices.value && cuadroVaricesInvalid}"
                        formControlName="c6asintomatico" inputId="c6asintomatico" label="" name="c6asintomatico"
                        [ngModel]="examen.c6asintomatico" [disabled]="examen?.modoVista === 'ver'">
                      </p-checkbox>
                    </td>
                    <td>
                      <p-checkbox class="tableVarices" (onChange)="clickTableVarices('c6sintomatico', $event.checked)" binary="true"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && f.varices.value && cuadroVaricesInvalid}"
                        formControlName="c6sintomatico" inputId="c6sintomatico" label="" name="c6sintomatico"
                        [ngModel]="examen.c6sintomatico" [disabled]="examen?.modoVista === 'ver'">
                      </p-checkbox>
                    </td>
                  </tr>
                </tbody>
              </table>
              <p>Cada Clase se debe completar con: (A)Asintomática, (s)Sintomática. Los síntomas escogidos son los dolores, el purito,
                la sensación de pesadez de las piernas, los calambres y todos los síntomas que puedan atribuirse a una insuficiencia venosa.
              </p>
              <app-invalid-from-message *ngIf="submitted && f.varices.value && cuadroVaricesInvalid"></app-invalid-from-message>
            </div>
            <div class="p-col-12 p-md-12 print_dont_break">
              <app-fiel-title label="Hemorroides"></app-fiel-title>
              <div style="display: flex; flex-direction: row;">
                <p-radioButton name="hemorroides" [value]="true" formControlName="hemorroides"
                  label="Si" [ngClass]="{'ng-invalid ng-dirty': submitted && f.hemorroides.invalid}"
                  [disabled]="examen?.modoVista === 'ver'" (onClick)="clickRadioButton('SI', 'HEMORROIDES')">
                </p-radioButton>
                <p-radioButton name="hemorroides" [value]="false" formControlName="hemorroides"
                  label="No" [ngClass]="{'ng-invalid ng-dirty': submitted && f.hemorroides.invalid}"
                  [disabled]="examen?.modoVista === 'ver'" (onClick)="clickRadioButton('NO', 'HEMORROIDES')">
                </p-radioButton>
              </div>
              <app-invalid-from-message *ngIf="submitted && f.hemorroides.invalid"></app-invalid-from-message>
            </div>
            <div class="p-col-12 p-md-12 print_dont_break">
              <app-fiel-title label="¿Realiza tratamiento?"></app-fiel-title>
              <div style="display: flex; flex-direction: row;">
                <p-radioButton name="realizaTratHemorroides" [value]="true" formControlName="realizaTratHemorroides"
                  label="Si" [ngClass]="{'ng-invalid ng-dirty': submitted && f.realizaTratHemorroides.invalid}"
                  [disabled]="examen?.modoVista === 'ver'" (onClick)="clickRadioButton('SI', 'TRAT_HEMORROIDES')">
                </p-radioButton>
                <p-radioButton name="realizaTratHemorroides" [value]="false" formControlName="realizaTratHemorroides"
                  label="No" [ngClass]="{'ng-invalid ng-dirty': submitted && f.realizaTratHemorroides.invalid}"
                  [disabled]="examen?.modoVista === 'ver'" (onClick)="clickRadioButton('NO', 'TRAT_HEMORROIDES')">
                </p-radioButton>
              </div>
              <app-invalid-from-message *ngIf="submitted && f.realizaTratHemorroides.invalid"></app-invalid-from-message>
            </div>
            <div class="p-col-12 p-md-6 print_dont_break">
              <app-fiel-title label="Descripción (Tratamiento)"></app-fiel-title>
              <p [ngClass]="{'print_show-on-print': f.descripcionRealizaTratHemorroides.value.length > 0,
                'print_hide-on-print': f.descripcionRealizaTratHemorroides.value.length < 1}"
                class="print_hidden-area-before-print print_row-full p-field-word-break">
                {{f.descripcionRealizaTratHemorroides.value}}
              </p>
              <textarea class="print_hide-on-print"
                [ngClass]="{'ng-invalid ng-dirty': submitted && f.descripcionRealizaTratHemorroides.invalid}" cols="30"
                formControlName="descripcionRealizaTratHemorroides" id="result" maxlength="1000" name="resul"
                pInputTextarea rows="5" [attr.disabled]="examen?.modoVista === 'ver' ? true : null">
              </textarea>
              <small style="text-align: end;">
                {{ f.descripcionRealizaTratHemorroides.value.length }}/1000
              </small>
              <app-invalid-from-message *ngIf="submitted && f.descripcionRealizaTratHemorroides.errors?.required">
              </app-invalid-from-message>
              <app-invalid-from-message *ngIf="f.descripcionRealizaTratHemorroides.errors?.maxlength"
                message="Solo se permiten {{ f.descripcionRealizaTratHemorroides.errors.maxlength.requiredLength  }} caracteres">
              </app-invalid-from-message>
            </div>
            <div class="p-col-12 p-md-6 print_dont_break">
              <app-fiel-title label="Observaciones"></app-fiel-title>
              <p [ngClass]="{'print_show-on-print': f.observacionesCardiocirculatorio.value.length > 0,
                'print_hide-on-print': f.observacionesCardiocirculatorio.value.length < 1}"
                class="print_hidden-area-before-print print_row-full p-field-word-break">
                {{f.observacionesCardiocirculatorio.value}}
              </p>
              <textarea class="print_hide-on-print"
                [ngClass]="{'ng-invalid ng-dirty': submitted && f.observacionesCardiocirculatorio.invalid}" cols="30"
                formControlName="observacionesCardiocirculatorio" id="result" maxlength="1000" name="resul"
                pInputTextarea rows="5" [attr.disabled]="examen?.modoVista === 'ver' ? true : null">
              </textarea>
              <small style="text-align: end;">
                {{ f.observacionesCardiocirculatorio.value.length }}/1000
              </small>
              <app-invalid-from-message *ngIf="submitted && f.observacionesCardiocirculatorio.errors?.required">
              </app-invalid-from-message>
              <app-invalid-from-message *ngIf="f.observacionesCardiocirculatorio.errors?.maxlength"
                message="Solo se permiten {{ f.observacionesCardiocirculatorio.errors.maxlength.requiredLength  }} caracteres">
              </app-invalid-from-message>
            </div>
          </div>
          <!--ABDOMEN-->
          <div *ngIf="configForm.findSection('Abdomen')" class="p-col-12 p-md-12">
            <p-divider></p-divider>
            <div class="p-col-12 p-md-12 print_dont_break">
              <app-fiel-title label="Abdomen con alteraciones" required="true"></app-fiel-title>
              <div style="display: flex; flex-direction: row; white-space: nowrap" [ngClass]="{'ng-invalid ng-dirty': submitted && f.abdomenAlteraciones.invalid }">
                <p-radioButton (onClick)="clickRadioButton('SI', 'ABDOMEN')" name="abdomenAlteraciones" [value]="true"
                  formControlName="abdomenAlteraciones" label="Si" [ngClass]="{'ng-invalid ng-dirty': submitted && f.abdomenAlteraciones.invalid}"
                  [disabled]="examen?.modoVista === 'ver'">
                </p-radioButton>
                <p-radioButton (onClick)="clickRadioButton('NO', 'ABDOMEN')" name="abdomenAlteraciones" [value]="false"
                  formControlName="abdomenAlteraciones" label="Se examinó y no presentó alteraciones"
                  [ngClass]="{'ng-invalid ng-dirty': submitted && f.abdomenAlteraciones.invalid}" [disabled]="examen?.modoVista === 'ver'">
                </p-radioButton>
              </div>
              <app-invalid-from-message *ngIf="submitted && f.abdomenAlteraciones.invalid"></app-invalid-from-message>
            </div>
            <div class="p-col-12 p-md-12 print_dont_break">
              <app-fiel-title label="Alteraciones"></app-fiel-title>
              <div class="p-field-checkbox-inline" style="display: flex; flex-direction: row;">
                <div class="p-field-checkbox">
                  <p-checkbox binary="true" [ngClass]="{'ng-invalid ng-dirty': submitted && f.abdomenAlteraciones.value && !f.hepatomegalia.value
                      && !f.cicatricesQuirurgicas.value && !f.esplenomegalia.value && !f.hernia.value && !f.otrasAbdomen.value}"
                    formControlName="hepatomegalia" inputId="hepatomegalia" label="Hepatomegalia" name="hepatomegalia"
                    [ngModel]="examen.hepatomegalia" [disabled]="examen?.modoVista === 'ver'">
                  </p-checkbox>
                </div>
                <div class="p-field-checkbox">
                  <p-checkbox binary="true" [ngClass]="{'ng-invalid ng-dirty': submitted && f.abdomenAlteraciones.value && !f.hepatomegalia.value
                      && !f.cicatricesQuirurgicas.value && !f.esplenomegalia.value && !f.hernia.value && !f.otrasAbdomen.value}"
                    formControlName="cicatricesQuirurgicas" inputId="cicatricesQuirurgicas" label="Cicatrices Quirúrgicas" name="cicatricesQuirurgicas"
                    [ngModel]="examen.cicatricesQuirurgicas" [disabled]="examen?.modoVista === 'ver'">
                  </p-checkbox>
                </div>
                <div class="p-field-checkbox">
                  <p-checkbox binary="true" [ngClass]="{'ng-invalid ng-dirty': submitted && f.abdomenAlteraciones.value && !f.hepatomegalia.value
                      && !f.cicatricesQuirurgicas.value && !f.esplenomegalia.value && !f.hernia.value && !f.otrasAbdomen.value}"
                    formControlName="esplenomegalia" inputId="esplenomegalia" label="Esplenomegalia" name="esplenomegalia"
                    [ngModel]="examen.esplenomegalia" [disabled]="examen?.modoVista === 'ver'">
                  </p-checkbox>
                </div>
                <div class="p-field-checkbox">
                  <p-checkbox (onChange)="clickCheckBox('hernia', $event)" binary="true"
                    [ngClass]="{'ng-invalid ng-dirty': submitted && f.abdomenAlteraciones.value && !f.hepatomegalia.value
                      && !f.cicatricesQuirurgicas.value && !f.esplenomegalia.value && !f.hernia.value && !f.otrasAbdomen.value}"
                    formControlName="hernia" inputId="hernia" label="Hernia" name="hernia"
                    [ngModel]="examen.hernia" [disabled]="examen?.modoVista === 'ver'">
                  </p-checkbox>
                </div>
                <div class="p-field-checkbox">
                  <p-checkbox (onChange)="clickCheckBox('otrasAbdomen', $event)" binary="true"
                    [ngClass]="{'ng-invalid ng-dirty': submitted && f.abdomenAlteraciones.value && !f.hepatomegalia.value
                      && !f.cicatricesQuirurgicas.value && !f.esplenomegalia.value && !f.hernia.value && !f.otrasAbdomen.value}"
                    formControlName="otrasAbdomen" inputId="otrasAbdomen" label="Otras" name="otrasAbdomen"
                    [ngModel]="examen.otrasAbdomen" [disabled]="examen?.modoVista === 'ver'">
                  </p-checkbox>
                </div>
              </div>
              <app-invalid-from-message *ngIf="submitted && f.abdomenAlteraciones.value && !f.hepatomegalia.value && !f.cicatricesQuirurgicas.value
                && !f.esplenomegalia.value && !f.hernia.value && !f.otrasAbdomen.value"></app-invalid-from-message>
            </div>
            <div class="p-col-12 p-md-6 print_row-full print_dont_break">
              <app-fiel-title label="Descripción (Otras)"></app-fiel-title>
              <p [ngClass]="{'print_show-on-print': f.descripcionAbdomen.value.length > 0,
                'print_hide-on-print': f.descripcionAbdomen.value.length < 1}"
                class="print_hidden-area-before-print print_row-full p-field-word-break">
                {{f.descripcionAbdomen.value}}
              </p>
              <textarea class="print_hide-on-print"
                [ngClass]="{'ng-invalid ng-dirty': submitted && f.descripcionAbdomen.invalid}" cols="30"
                formControlName="descripcionAbdomen" id="result" maxlength="1000" name="resul"
                pInputTextarea rows="5" [attr.disabled]="examen?.modoVista === 'ver' ? true : null">
              </textarea>
              <small style="text-align: end;">
                {{ f.descripcionAbdomen.value.length }}/1000
              </small>
              <app-invalid-from-message *ngIf="submitted && f.descripcionAbdomen.errors?.required">
              </app-invalid-from-message>
              <app-invalid-from-message *ngIf="f.descripcionAbdomen.errors?.maxlength"
                message="Solo se permiten {{ f.descripcionAbdomen.errors.maxlength.requiredLength  }} caracteres">
              </app-invalid-from-message>
            </div>
            <div class="p-col-12 p-md-6">
              <table class="p-datatable-solid" [ngClass]="{'enabled': enableTableHernias}">
                <thead>
                  <tr>
                    <th class="no-border-cell"></th>
                    <th>Derecho</th>
                    <th>Izquierdo</th>
                    <th>Bilateral</th>
                    <th>Reductible</th>
                    <th>No Reductible</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Inguinal - Directa</td>
                    <td>
                      <p-checkbox class="tableHernias" (onChange)="clickTableHernias('inguinalDirectaDerecha', $event.checked)" binary="true"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && f.hernia.value && cuadroHerniasInvalid}"
                        formControlName="inguinalDirectaDerecha" inputId="inguinalDirectaDerecha" label="" name="inguinalDirectaDerecha"
                        [ngModel]="examen.inguinalDirectaDerecha" [disabled]="examen?.modoVista === 'ver'">
                      </p-checkbox>
                    </td>
                    <td>
                      <p-checkbox class="tableHernias" (onChange)="clickTableHernias('inguinalDirectaIzquierda', $event.checked)" binary="true"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && f.hernia.value && cuadroHerniasInvalid}"
                        formControlName="inguinalDirectaIzquierda" inputId="inguinalDirectaIzquierda" label="" name="inguinalDirectaIzquierda"
                        [ngModel]="examen.inguinalDirectaIzquierda" [disabled]="examen?.modoVista === 'ver'">
                      </p-checkbox>
                    </td>
                    <td>
                      <p-checkbox class="tableHernias" (onChange)="clickTableHernias('inguinalDirectaBilateral', $event.checked)" binary="true"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && f.hernia.value && cuadroHerniasInvalid}"
                        formControlName="inguinalDirectaBilateral" inputId="inguinalDirectaBilateral" label="" name="inguinalDirectaBilateral"
                        [ngModel]="examen.inguinalDirectaBilateral" [disabled]="examen?.modoVista === 'ver'">
                      </p-checkbox>
                    </td>
                    <td>
                      <p-checkbox class="tableHernias" (onChange)="clickTableHernias('inguinalDirectaReductible', $event.checked)" binary="true"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && f.hernia.value && cuadroHerniasInvalid}"
                        formControlName="inguinalDirectaReductible" inputId="inguinalDirectaReductible" label="" name="inguinalDirectaReductible"
                        [ngModel]="examen.inguinalDirectaReductible" [disabled]="examen?.modoVista === 'ver'">
                      </p-checkbox>
                    </td>
                    <td>
                      <p-checkbox class="tableHernias" (onChange)="clickTableHernias('inguinalDirectaNoReductible', $event.checked)" binary="true"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && f.hernia.value && cuadroHerniasInvalid}"
                        formControlName="inguinalDirectaNoReductible" inputId="inguinalDirectaNoReductible" label="" name="inguinalDirectaNoReductible"
                        [ngModel]="examen.inguinalDirectaNoReductible" [disabled]="examen?.modoVista === 'ver'">
                      </p-checkbox>
                    </td>
                  </tr>
                  <tr>
                    <td>Inguinal - Indirecta</td>
                    <td>
                      <p-checkbox class="tableHernias" (onChange)="clickTableHernias('inguinalIndirectaDerecha', $event)" binary="true"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && f.hernia.value && cuadroHerniasInvalid}"
                        formControlName="inguinalIndirectaDerecha" inputId="inguinalIndirectaDerecha" label="" name="inguinalIndirectaDerecha"
                        [ngModel]="examen.inguinalIndirectaDerecha" [disabled]="examen?.modoVista === 'ver'">
                      </p-checkbox>
                    </td>
                    <td>
                      <p-checkbox class="tableHernias" (onChange)="clickTableHernias('inguinalIndirectaIzquierda', $event)" binary="true"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && f.hernia.value && cuadroHerniasInvalid}"
                        formControlName="inguinalIndirectaIzquierda" inputId="inguinalIndirectaIzquierda" label="" name="inguinalIndirectaIzquierda"
                        [ngModel]="examen.inguinalIndirectaIzquierda" [disabled]="examen?.modoVista === 'ver'">
                      </p-checkbox>
                    </td>
                    <td>
                      <p-checkbox class="tableHernias" (onChange)="clickTableHernias('inguinalIndirectaBilateral', $event)" binary="true"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && f.hernia.value && cuadroHerniasInvalid}"
                        formControlName="inguinalIndirectaBilateral" inputId="inguinalIndirectaBilateral" label="" name="inguinalIndirectaBilateral"
                        [ngModel]="examen.inguinalIndirectaBilateral" [disabled]="examen?.modoVista === 'ver'">
                      </p-checkbox>
                    </td>
                    <td>
                      <p-checkbox class="tableHernias" (onChange)="clickTableHernias('inguinalIndirectaReductible', $event)" binary="true"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && f.hernia.value && cuadroHerniasInvalid}"
                        formControlName="inguinalIndirectaReductible" inputId="inguinalIndirectaReductible" label="" name="inguinalIndirectaReductible"
                        [ngModel]="examen.inguinalIndirectaReductible" [disabled]="examen?.modoVista === 'ver'">
                      </p-checkbox>
                    </td>
                    <td>
                      <p-checkbox class="tableHernias" (onChange)="clickTableHernias('inguinalIndirectaNoReductible', $event)" binary="true"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && f.hernia.value && cuadroHerniasInvalid}"
                        formControlName="inguinalIndirectaNoReductible" inputId="inguinalIndirectaNoReductible" label="" name="inguinalIndirectaNoReductible"
                        [ngModel]="examen.inguinalIndirectaNoReductible" [disabled]="examen?.modoVista === 'ver'">
                      </p-checkbox>
                    </td>
                  </tr>
                  <tr>
                    <td>Inguinal - Mixta</td>
                    <td>
                      <p-checkbox class="tableHernias" (onChange)="clickTableHernias('inguinalMixtaDerecha', $event)" binary="true"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && f.hernia.value && cuadroHerniasInvalid}"
                        formControlName="inguinalMixtaDerecha" inputId="inguinalMixtaDerecha" label="" name="inguinalMixtaDerecha"
                        [ngModel]="examen.inguinalMixtaDerecha" [disabled]="examen?.modoVista === 'ver'">
                      </p-checkbox>
                    </td>
                    <td>
                      <p-checkbox class="tableHernias" (onChange)="clickTableHernias('inguinalMixtaIzquierda', $event)" binary="true"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && f.hernia.value && cuadroHerniasInvalid}"
                        formControlName="inguinalMixtaIzquierda" inputId="inguinalMixtaIzquierda" label="" name="inguinalMixtaIzquierda"
                        [ngModel]="examen.inguinalMixtaIzquierda" [disabled]="examen?.modoVista === 'ver'">
                      </p-checkbox>
                    </td>
                    <td>
                      <p-checkbox class="tableHernias" (onChange)="clickTableHernias('inguinalMixtaBilateral', $event)" binary="true"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && f.hernia.value && cuadroHerniasInvalid}"
                        formControlName="inguinalMixtaBilateral" inputId="inguinalMixtaBilateral" label="" name="inguinalMixtaBilateral"
                        [ngModel]="examen.inguinalMixtaBilateral" [disabled]="examen?.modoVista === 'ver'">
                      </p-checkbox>
                    </td>
                    <td>
                      <p-checkbox class="tableHernias" (onChange)="clickTableHernias('inguinalMixtaReductible', $event)" binary="true"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && f.hernia.value && cuadroHerniasInvalid}"
                        formControlName="inguinalMixtaReductible" inputId="inguinalMixtaReductible" label="" name="inguinalMixtaReductible"
                        [ngModel]="examen.inguinalMixtaReductible" [disabled]="examen?.modoVista === 'ver'">
                      </p-checkbox>
                    </td>
                    <td>
                      <p-checkbox class="tableHernias" (onChange)="clickTableHernias('inguinalMixtaNoReductible', $event)" binary="true"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && f.hernia.value && cuadroHerniasInvalid}"
                        formControlName="inguinalMixtaNoReductible" inputId="inguinalMixtaNoReductible" label="" name="inguinalMixtaNoReductible"
                        [ngModel]="examen.inguinalMixtaNoReductible" [disabled]="examen?.modoVista === 'ver'">
                      </p-checkbox>
                    </td>
                  </tr>
                  <tr>
                    <td>Crural</td>
                    <td>
                      <p-checkbox class="tableHernias" (onChange)="clickTableHernias('curalDerecha', $event)" binary="true"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && f.hernia.value && cuadroHerniasInvalid}"
                        formControlName="curalDerecha" inputId="curalDerecha" label="" name="curalDerecha"
                        [ngModel]="examen.curalDerecha" [disabled]="examen?.modoVista === 'ver'">
                      </p-checkbox>
                    </td>
                    <td>
                      <p-checkbox class="tableHernias" (onChange)="clickTableHernias('curalIzquierda', $event)" binary="true"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && f.hernia.value && cuadroHerniasInvalid}"
                        formControlName="curalIzquierda" inputId="curalIzquierda" label="" name="curalIzquierda"
                        [ngModel]="examen.curalIzquierda" [disabled]="examen?.modoVista === 'ver'">
                      </p-checkbox>
                    </td>
                    <td>
                      <p-checkbox class="tableHernias" (onChange)="clickTableHernias('curalBilateral', $event)" binary="true"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && f.hernia.value && cuadroHerniasInvalid}"
                        formControlName="curalBilateral" inputId="curalBilateral" label="" name="curalBilateral"
                        [ngModel]="examen.curalBilateral" [disabled]="examen?.modoVista === 'ver'">
                      </p-checkbox>
                    </td>
                    <td>
                      <p-checkbox class="tableHernias" (onChange)="clickTableHernias('curalReductible', $event)" binary="true"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && f.hernia.value && cuadroHerniasInvalid}"
                        formControlName="curalReductible" inputId="curalReductible" label="" name="curalReductible"
                        [ngModel]="examen.curalReductible" [disabled]="examen?.modoVista === 'ver'">
                      </p-checkbox>
                    </td>
                    <td>
                      <p-checkbox class="tableHernias" (onChange)="clickTableHernias('curalNoReductible', $event)" binary="true"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && f.hernia.value && cuadroHerniasInvalid}"
                        formControlName="curalNoReductible" inputId="curalNoReductible" label="" name="curalNoReductible"
                        [ngModel]="examen.curalNoReductible" [disabled]="examen?.modoVista === 'ver'">
                      </p-checkbox>
                    </td>
                  </tr>
                </tbody>
              </table>
              <app-invalid-from-message *ngIf="submitted && f.hernia.value && cuadroHerniasInvalid"></app-invalid-from-message>
            </div>
            <div class="p-col-12 p-md-12 print_dont_break">
              <app-fiel-title label="Hernia umbilical"></app-fiel-title>
              <div style="display: flex; flex-direction: row;">
                <p-radioButton name="umbilical" [value]="true" formControlName="umbilical"
                  label="Si" [ngClass]="{'ng-invalid ng-dirty': submitted && f.umbilical.invalid}"
                  [disabled]="examen?.modoVista === 'ver'">
                </p-radioButton>
                <p-radioButton name="umbilical" [value]="false" formControlName="umbilical"
                  label="No" [ngClass]="{'ng-invalid ng-dirty': submitted && f.umbilical.invalid}"
                  [disabled]="examen?.modoVista === 'ver'">
                </p-radioButton>
              </div>
              <app-invalid-from-message *ngIf="submitted && f.umbilical.invalid"></app-invalid-from-message>
            </div>
            <div class="p-field p-col-12 p-md-6 print_row-full print_dont_break">
              <app-fiel-title label="Dolor, molestia en región inguinal"></app-fiel-title>
              <span class="print_edadInputNumber_hide print_show-on-print print_filled_input">
                {{f.dolorMolestiaRegionInguinal.value}}
              </span>
              <input [ngClass]="{'ng-invalid ng-dirty': submitted && f.dolorMolestiaRegionInguinal.invalid}"
                formControlName="dolorMolestiaRegionInguinal" id="dolorMolestiaRegionInguinal" name="dolorMolestiaRegionInguinal" maxlength="60"
                pInputText type="text" [attr.disabled]="examen?.modoVista === 'ver' ? true : null" />
              <app-invalid-from-message *ngIf="submitted && f.dolorMolestiaRegionInguinal.invalid"></app-invalid-from-message>
            </div>
            <div class="p-col-12 p-md-12 print_dont_break">
              <app-fiel-title label="Hernia incipiente"></app-fiel-title>
              <div style="display: flex; flex-direction: row;">
                <p-radioButton name="herniaIncipiente" [value]="true" formControlName="herniaIncipiente"
                  label="Si" [ngClass]="{'ng-invalid ng-dirty': submitted && f.herniaIncipiente.invalid}"
                  [disabled]="examen?.modoVista === 'ver'">
                </p-radioButton>
                <p-radioButton name="herniaIncipiente" [value]="false" formControlName="herniaIncipiente"
                  label="No" [ngClass]="{'ng-invalid ng-dirty': submitted && f.herniaIncipiente.invalid}"
                  [disabled]="examen?.modoVista === 'ver'">
                </p-radioButton>
              </div>
              <app-invalid-from-message *ngIf="submitted && f.herniaIncipiente.invalid"></app-invalid-from-message>
            </div>
            <div class="p-col-12 p-md-12 print_dont_break">
              <app-fiel-title label="Anillo herniario"></app-fiel-title>
              <div style="display: flex; flex-direction: row; white-space: nowrap">
                <p-radioButton name="anilloHerniarioComplaciente" [value]="true" formControlName="anilloHerniarioComplaciente"
                  label="Complaciente" [ngClass]="{'ng-invalid ng-dirty': submitted && f.anilloHerniarioComplaciente.invalid}"
                  [disabled]="examen?.modoVista === 'ver'">
                </p-radioButton>
                <p-radioButton name="anilloHerniarioComplaciente" [value]="false" formControlName="anilloHerniarioComplaciente"
                  label="No Complaciente" [ngClass]="{'ng-invalid ng-dirty': submitted && f.anilloHerniarioComplaciente.invalid}"
                  [disabled]="examen?.modoVista === 'ver'">
                </p-radioButton>
              </div>
              <app-invalid-from-message *ngIf="submitted && f.anilloHerniarioComplaciente.invalid"></app-invalid-from-message>
            </div>
            <div class="p-col-12 p-md-6 print_row-full print_dont_break">
              <app-fiel-title label="Observaciones"></app-fiel-title>
              <p [ngClass]="{'print_show-on-print': f.observacionesAbdomen.value.length > 0,
                'print_hide-on-print': f.observacionesAbdomen.value.length < 1}"
                class="print_hidden-area-before-print print_row-full p-field-word-break">
                {{f.observacionesAbdomen.value}}
              </p>
              <textarea class="print_hide-on-print"
                [ngClass]="{'ng-invalid ng-dirty': submitted && f.observacionesAbdomen.invalid}" cols="30"
                formControlName="observacionesAbdomen" id="result" maxlength="1000" name="resul"
                pInputTextarea rows="5" [attr.disabled]="examen?.modoVista === 'ver' ? true : null">
              </textarea>
              <small style="text-align: end;">
                {{ f.observacionesAbdomen.value.length }}/1000
              </small>
              <app-invalid-from-message *ngIf="submitted && f.observacionesAbdomen.errors?.required">
              </app-invalid-from-message>
              <app-invalid-from-message *ngIf="f.observacionesAbdomen.errors?.maxlength"
                message="Solo se permiten {{ f.observacionesAbdomen.errors.maxlength.requiredLength  }} caracteres">
              </app-invalid-from-message>
            </div>
          </div>
          <!--COLUMNA VERTEBRAL-->
          <div *ngIf="configForm.findSection('Columna Vertebral')" class="p-col-12 p-md-12">
            <p-divider></p-divider>
            <div class="p-col-12 p-md-12 print_dont_break">
              <app-fiel-title label="Columna Vertebral con alteraciones" required="true"></app-fiel-title>
              <div style="display: flex; flex-direction: row; white-space: nowrap" [ngClass]="{'ng-invalid ng-dirty': submitted && f.columnaVertebralAlteraciones.invalid }">
                <p-radioButton name="columnaVertebralAlteraciones" [value]="true" formControlName="columnaVertebralAlteraciones"
                  label="Si" [ngClass]="{'ng-invalid ng-dirty': submitted && f.columnaVertebralAlteraciones.invalid}"
                  [disabled]="examen?.modoVista === 'ver'" (onClick)="clickRadioButton('SI', 'COLUMNA')">
                </p-radioButton>
                <p-radioButton name="columnaVertebralAlteraciones" [value]="false" formControlName="columnaVertebralAlteraciones"
                  label="Se examinó y no presentó alteraciones" [ngClass]="{'ng-invalid ng-dirty': submitted && f.columnaVertebralAlteraciones.invalid}"
                  [disabled]="examen?.modoVista === 'ver'" (onClick)="clickRadioButton('NO', 'COLUMNA')">
                </p-radioButton>
              </div>
              <app-invalid-from-message *ngIf="submitted && f.columnaVertebralAlteraciones.invalid"></app-invalid-from-message>
            </div>
            <div class="p-col-12 p-md-12 print_dont_break">
              <app-fiel-title label="Cicatrices quirúrgicas"></app-fiel-title>
              <div class="p-field-checkbox-inline" style="display: flex; flex-direction: row;">
                <div class="p-field-checkbox">
                  <p-checkbox binary="true" [ngClass]="{'ng-invalid ng-dirty': submitted && columnaVertebralInvalid}"
                    formControlName="cicatricesQuirurgicasCc" inputId="cicatricesQuirurgicasCc" label="(CC)" name="cicatricesQuirurgicasCc"
                    [ngModel]="examen.cicatricesQuirurgicasCc" [disabled]="examen?.modoVista === 'ver'"
                    class="alteracionesColumna" (onChange)="validateSeccionColumna()">
                  </p-checkbox>
                </div>
                <div class="p-field-checkbox">
                  <p-checkbox binary="true" [ngClass]="{'ng-invalid ng-dirty': submitted && columnaVertebralInvalid}"
                    formControlName="cicatricesQuirurgicasCd" inputId="cicatricesQuirurgicasCd" label="(CD)" name="cicatricesQuirurgicasCd"
                    [ngModel]="examen.cicatricesQuirurgicasCd" [disabled]="examen?.modoVista === 'ver'"
                    class="alteracionesColumna" (onChange)="validateSeccionColumna()">
                  </p-checkbox>
                </div>
                <div class="p-field-checkbox">
                  <p-checkbox binary="true" [ngClass]="{'ng-invalid ng-dirty': submitted && columnaVertebralInvalid}"
                    formControlName="cicatricesQuirurgicasCls" inputId="cicatricesQuirurgicasCls" label="(CLS)" name="cicatricesQuirurgicasCls"
                    [ngModel]="examen.cicatricesQuirurgicasCls" [disabled]="examen?.modoVista === 'ver'"
                    class="alteracionesColumna" (onChange)="validateSeccionColumna()">
                  </p-checkbox>
                </div>
              </div>
            </div>
            <div class="p-col-12 p-md-12 print_dont_break">
              <app-fiel-title label="Contractura muscular"></app-fiel-title>
              <div class="p-field-checkbox-inline" style="display: flex; flex-direction: row;">
                <div class="p-field-checkbox">
                  <p-checkbox binary="true" [ngClass]="{'ng-invalid ng-dirty': submitted && columnaVertebralInvalid}"
                    formControlName="contracturaMuscularCc" inputId="contracturaMuscularCc" label="(CC)" name="contracturaMuscularCc"
                    [ngModel]="examen.contracturaMuscularCc" [disabled]="examen?.modoVista === 'ver'"
                    class="alteracionesColumna" (onChange)="validateSeccionColumna()">
                  </p-checkbox>
                </div>
                <div class="p-field-checkbox">
                  <p-checkbox binary="true" [ngClass]="{'ng-invalid ng-dirty': submitted && columnaVertebralInvalid}"
                    formControlName="contracturaMuscularCd" inputId="contracturaMuscularCd" label="(CD)" name="contracturaMuscularCd"
                    [ngModel]="examen.contracturaMuscularCd" [disabled]="examen?.modoVista === 'ver'"
                    class="alteracionesColumna" (onChange)="validateSeccionColumna()">
                  </p-checkbox>
                </div>
                <div class="p-field-checkbox">
                  <p-checkbox binary="true" [ngClass]="{'ng-invalid ng-dirty': submitted && columnaVertebralInvalid}"
                    formControlName="contracturaMuscularCls" inputId="contracturaMuscularCls" label="(CLS)" name="contracturaMuscularCls"
                    [ngModel]="examen.contracturaMuscularCls" [disabled]="examen?.modoVista === 'ver'"
                    class="alteracionesColumna" (onChange)="validateSeccionColumna()">
                  </p-checkbox>
                </div>
              </div>
            </div>
            <div class="p-col-12 p-md-12 print_dont_break">
              <app-fiel-title label="Lasegue positivo"></app-fiel-title>
              <div class="p-field-checkbox-inline" style="display: flex; flex-direction: row;">
                <div class="p-field-checkbox">
                  <p-checkbox binary="true" [ngClass]="{'ng-invalid ng-dirty': submitted && columnaVertebralInvalid}"
                    formControlName="leseguePositivoDer" inputId="leseguePositivoDer" label="(DER)" name="leseguePositivoDer"
                    [ngModel]="examen.leseguePositivoDer" [disabled]="examen?.modoVista === 'ver'"
                    class="alteracionesColumna" (onChange)="validateSeccionColumna()">
                  </p-checkbox>
                </div>
                <div class="p-field-checkbox">
                  <p-checkbox binary="true" [ngClass]="{'ng-invalid ng-dirty': submitted && columnaVertebralInvalid}"
                    formControlName="leseguePositivoIzq" inputId="leseguePositivoIzq" label="(IZQ)" name="leseguePositivoIzq"
                    [ngModel]="examen.leseguePositivoIzq" [disabled]="examen?.modoVista === 'ver'"
                    class="alteracionesColumna" (onChange)="validateSeccionColumna()">
                  </p-checkbox>
                </div>
              </div>
            </div>
            <div class="p-col-12 p-md-12 print_dont_break">
              <app-fiel-title label="Puntos dolorosos"></app-fiel-title>
              <div class="p-field-checkbox-inline" style="display: flex; flex-direction: row;">
                <div class="p-field-checkbox">
                  <p-checkbox binary="true" [ngClass]="{'ng-invalid ng-dirty': submitted && columnaVertebralInvalid}"
                    formControlName="puntosDolorososCc" inputId="puntosDolorososCc" label="(CC)" name="puntosDolorososCc"
                    [ngModel]="examen.puntosDolorososCc" [disabled]="examen?.modoVista === 'ver'"
                    class="alteracionesColumna" (onChange)="validateSeccionColumna()">
                  </p-checkbox>
                </div>
                <div class="p-field-checkbox">
                  <p-checkbox binary="true" [ngClass]="{'ng-invalid ng-dirty': submitted && columnaVertebralInvalid}"
                    formControlName="puntosDolorososCd" inputId="puntosDolorososCd" label="(CD)" name="puntosDolorososCd"
                    [ngModel]="examen.puntosDolorososCd" [disabled]="examen?.modoVista === 'ver'"
                    class="alteracionesColumna" (onChange)="validateSeccionColumna()">
                  </p-checkbox>
                </div>
                <div class="p-field-checkbox">
                  <p-checkbox binary="true" [ngClass]="{'ng-invalid ng-dirty': submitted && columnaVertebralInvalid}"
                    formControlName="puntosDolorososCls" inputId="puntosDolorososCls" label="(CLS)" name="puntosDolorososCls"
                    [ngModel]="examen.puntosDolorososCls" [disabled]="examen?.modoVista === 'ver'"
                    class="alteracionesColumna" (onChange)="validateSeccionColumna()">
                  </p-checkbox>
                </div>
              </div>
            </div>
            <div class="p-col-12 p-md-12 print_dont_break">
              <app-fiel-title label="Deformidad (Lordosis, escoliosis, etc)"></app-fiel-title>
              <div class="p-field-checkbox-inline" style="display: flex; flex-direction: row;">
                <div class="p-field-checkbox">
                  <p-checkbox binary="true" [ngClass]="{'ng-invalid ng-dirty': submitted && columnaVertebralInvalid}"
                    formControlName="deformidadCc" inputId="deformidadCc" label="(CC)" name="deformidadCc"
                    [ngModel]="examen.deformidadCc" [disabled]="examen?.modoVista === 'ver'"
                    class="alteracionesColumna" (onChange)="validateSeccionColumna()">
                  </p-checkbox>
                </div>
                <div class="p-field-checkbox">
                  <p-checkbox binary="true" [ngClass]="{'ng-invalid ng-dirty': submitted && columnaVertebralInvalid}"
                    formControlName="deformidadCd" inputId="deformidadCd" label="(CD)" name="deformidadCd"
                    [ngModel]="examen.deformidadCd" [disabled]="examen?.modoVista === 'ver'"
                    class="alteracionesColumna" (onChange)="validateSeccionColumna()">
                  </p-checkbox>
                </div>
                <div class="p-field-checkbox">
                  <p-checkbox binary="true" [ngClass]="{'ng-invalid ng-dirty': submitted && columnaVertebralInvalid}"
                    formControlName="deformidadCls" inputId="deformidadCls" label="(CLS)" name="deformidadCls"
                    [ngModel]="examen.deformidadCls" [disabled]="examen?.modoVista === 'ver'"
                    class="alteracionesColumna" (onChange)="validateSeccionColumna()">
                  </p-checkbox>
                </div>
              </div>
            </div>
            <div class="p-col-12 p-md-12 print_dont_break">
              <app-fiel-title label="Limitaciones en la movilidad"></app-fiel-title>
              <div class="p-field-checkbox-inline" style="display: flex; flex-direction: row;">
                <div class="p-field-checkbox">
                  <p-checkbox binary="true" [ngClass]="{'ng-invalid ng-dirty': submitted && columnaVertebralInvalid}"
                    formControlName="limitacionesMovilidadCc" inputId="limitacionesMovilidadCc" label="(CC)" name="limitacionesMovilidadCc"
                    [ngModel]="examen.limitacionesMovilidadCc" [disabled]="examen?.modoVista === 'ver'"
                    class="alteracionesColumna" (onChange)="validateSeccionColumna()">
                  </p-checkbox>
                </div>
                <div class="p-field-checkbox">
                  <p-checkbox binary="true" [ngClass]="{'ng-invalid ng-dirty': submitted && columnaVertebralInvalid}"
                    formControlName="limitacionesMovilidadCd" inputId="limitacionesMovilidadCd" label="(CD)" name="limitacionesMovilidadCd"
                    [ngModel]="examen.limitacionesMovilidadCd" [disabled]="examen?.modoVista === 'ver'"
                    class="alteracionesColumna" (onChange)="validateSeccionColumna()">
                  </p-checkbox>
                </div>
                <div class="p-field-checkbox">
                  <p-checkbox binary="true" [ngClass]="{'ng-invalid ng-dirty': submitted && columnaVertebralInvalid}"
                    formControlName="limitacionesMovilidadCls" inputId="limitacionesMovilidadCls" label="(CLS)" name="limitacionesMovilidadCls"
                    [ngModel]="examen.limitacionesMovilidadCls" [disabled]="examen?.modoVista === 'ver'"
                    class="alteracionesColumna" (onChange)="validateSeccionColumna()">
                  </p-checkbox>
                </div>
              </div>
            </div>
            <app-invalid-from-message *ngIf="submitted && f.columnaVertebralAlteraciones.value && columnaVertebralInvalid"></app-invalid-from-message>
            <div class="p-col-12 p-md-6">
              <p>
                CC (Columna Cervical) - CD (Columna Dorsal) - CLS (Columna Lumbosacra)
              </p>
            </div>
            <div class="p-col-12 p-md-6 print_row-full print_dont_break">
              <app-fiel-title label="Observaciones"></app-fiel-title>
              <p [ngClass]="{'print_show-on-print': f.observacionesColumnaVertebral.value.length > 0,
                'print_hide-on-print': f.observacionesColumnaVertebral.value.length < 1}"
                class="print_hidden-area-before-print print_row-full p-field-word-break">
                {{f.observacionesColumnaVertebral.value}}
              </p>
              <textarea class="print_hide-on-print"
                [ngClass]="{'ng-invalid ng-dirty': submitted && f.observacionesColumnaVertebral.invalid}" cols="30"
                formControlName="observacionesColumnaVertebral" id="result" maxlength="1000" name="resul"
                pInputTextarea rows="5" [attr.disabled]="examen?.modoVista === 'ver' ? true : null">
              </textarea>
              <small style="text-align: end;">
                {{ f.observacionesColumnaVertebral.value.length }}/1000
              </small>
              <app-invalid-from-message *ngIf="submitted && f.observacionesColumnaVertebral.errors?.required">
              </app-invalid-from-message>
              <app-invalid-from-message *ngIf="f.observacionesColumnaVertebral.errors?.maxlength"
                message="Solo se permiten {{ f.observacionesColumnaVertebral.errors.maxlength.requiredLength  }} caracteres">
              </app-invalid-from-message>
            </div>
          </div>
          <!--OSTEOARTICULAR-->
          <div *ngIf="configForm.findSection('Osteoarticular')" class="p-col-12 p-md-12">
            <p-divider></p-divider>
            <div class="p-col-12 p-md-12 print_dont_break">
              <app-fiel-title label="Estudio osteoarticular con alteraciones" required="true"></app-fiel-title>
              <div style="display: flex; flex-direction: row;" [ngClass]="{'ng-invalid ng-dirty': submitted && f.osteoarticularAlteraciones.invalid }">
                <p-radioButton name="osteoarticularAlteraciones" [value]="true" formControlName="osteoarticularAlteraciones"
                  label="Si" [ngClass]="{'ng-invalid ng-dirty': submitted && f.osteoarticularAlteraciones.invalid}"
                  [disabled]="examen?.modoVista === 'ver'" (onClick)="clickRadioButton('SI', 'OSTEO')">
                </p-radioButton>
                <p-radioButton name="osteoarticularAlteraciones" [value]="false" formControlName="osteoarticularAlteraciones"
                  label="Se examinó y no presentó alteraciones" [ngClass]="{'ng-invalid ng-dirty': submitted && f.osteoarticularAlteraciones.invalid}"
                  [disabled]="examen?.modoVista === 'ver'" (onClick)="clickRadioButton('NO', 'OSTEO')">
                </p-radioButton>
              </div>
              <app-invalid-from-message *ngIf="submitted && f.osteoarticularAlteraciones.invalid"></app-invalid-from-message>
            </div>
            <div class="p-col-12 p-md-8 print_dont_break">
              <app-fiel-title label="Alteraciones"></app-fiel-title>
              <div style="display: flex;">
                <div class="p-md-3">
                  <div class="p-field-checkbox">
                    <p-checkbox binary="true" [ngClass]="{'ng-invalid ng-dirty': submitted && f.osteoarticularAlteraciones.value && !f.miembroSuperiorIzq.value
                        && !f.miembroSuperiorDer.value && !f.manoDer.value && !f.manoIzq.value && !f.dedosManoDerecha.value && !f.dedosManoIzquierda.value
                        && !f.rodillaIzq.value && !f.rodillaDer.value && !f.pieIzq.value && !f.miembroInferiorDer.value
                        && !f.pieDer.value && !f.miembroInferiorIzq.value}"
                      formControlName="miembroSuperiorDer" inputId="miembroSuperiorDer" label="Miembro S.D." name="miembroSuperiorDer"
                      [ngModel]="examen.miembroSuperiorDer" [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </div>
                  <div class="p-field-checkbox">
                    <p-checkbox binary="true" [ngClass]="{'ng-invalid ng-dirty': submitted && f.osteoarticularAlteraciones.value && !f.miembroSuperiorIzq.value
                        && !f.miembroSuperiorDer.value && !f.manoDer.value && !f.manoIzq.value && !f.dedosManoDerecha.value && !f.dedosManoIzquierda.value
                        && !f.rodillaIzq.value && !f.rodillaDer.value && !f.pieIzq.value && !f.miembroInferiorDer.value
                        && !f.pieDer.value && !f.miembroInferiorIzq.value}"
                      formControlName="dedosManoDerecha" inputId="dedosManoDerecha" label="Dedos mano derecha" name="dedosManoDerecha"
                      [ngModel]="examen.dedosManoDerecha" [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </div>
                  <div class="p-field-checkbox">
                    <p-checkbox binary="true" [ngClass]="{'ng-invalid ng-dirty': submitted && f.osteoarticularAlteraciones.value && !f.miembroSuperiorIzq.value
                        && !f.miembroSuperiorDer.value && !f.manoDer.value && !f.manoIzq.value && !f.dedosManoDerecha.value && !f.dedosManoIzquierda.value
                        && !f.rodillaIzq.value && !f.rodillaDer.value && !f.pieIzq.value && !f.miembroInferiorDer.value
                        && !f.pieDer.value && !f.miembroInferiorIzq.value}"
                      formControlName="rodillaDer" inputId="rodillaDer" label="Rodilla derecha" name="rodillaDer"
                      [ngModel]="examen.rodillaDer" [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </div>
                </div>
                <div class="p-md-3">
                  <div class="p-field-checkbox">
                    <p-checkbox binary="true" [ngClass]="{'ng-invalid ng-dirty': submitted && f.osteoarticularAlteraciones.value && !f.miembroSuperiorIzq.value
                        && !f.miembroSuperiorDer.value && !f.manoDer.value && !f.manoIzq.value && !f.dedosManoDerecha.value && !f.dedosManoIzquierda.value
                        && !f.rodillaIzq.value && !f.rodillaDer.value && !f.pieIzq.value && !f.miembroInferiorDer.value
                        && !f.pieDer.value && !f.miembroInferiorIzq.value}"
                      formControlName="miembroSuperiorIzq" inputId="miembroSuperiorIzq" label="Miembro S.I." name="miembroSuperiorIzq"
                      [ngModel]="examen.miembroSuperiorIzq" [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </div>
                  <div class="p-field-checkbox">
                    <p-checkbox binary="true" [ngClass]="{'ng-invalid ng-dirty': submitted && f.osteoarticularAlteraciones.value && !f.miembroSuperiorIzq.value
                        && !f.miembroSuperiorDer.value && !f.manoDer.value && !f.manoIzq.value && !f.dedosManoDerecha.value && !f.dedosManoIzquierda.value
                        && !f.rodillaIzq.value && !f.rodillaDer.value && !f.pieIzq.value && !f.miembroInferiorDer.value
                        && !f.pieDer.value && !f.miembroInferiorIzq.value}"
                      formControlName="dedosManoIzquierda" inputId="dedosManoIzquierda" label="Dedos mano Izquierda" name="dedosManoIzquierda"
                      [ngModel]="examen.dedosManoIzquierda" [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </div>
                  <div class="p-field-checkbox">
                    <p-checkbox binary="true" [ngClass]="{'ng-invalid ng-dirty': submitted && f.osteoarticularAlteraciones.value && !f.miembroSuperiorIzq.value
                        && !f.miembroSuperiorDer.value && !f.manoDer.value && !f.manoIzq.value && !f.dedosManoDerecha.value && !f.dedosManoIzquierda.value
                        && !f.rodillaIzq.value && !f.rodillaDer.value && !f.pieIzq.value && !f.miembroInferiorDer.value
                        && !f.pieDer.value && !f.miembroInferiorIzq.value}"
                      formControlName="rodillaIzq" inputId="rodillaIzq" label="Rodilla izquierda" name="rodillaIzq"
                      [ngModel]="examen.rodillaIzq" [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </div>
                </div>
                <div class="p-md-3">
                  <div class="p-field-checkbox">
                    <p-checkbox binary="true" [ngClass]="{'ng-invalid ng-dirty': submitted && f.osteoarticularAlteraciones.value && !f.miembroSuperiorIzq.value
                        && !f.miembroSuperiorDer.value && !f.manoDer.value && !f.manoIzq.value && !f.dedosManoDerecha.value && !f.dedosManoIzquierda.value
                        && !f.rodillaIzq.value && !f.rodillaDer.value && !f.pieIzq.value && !f.miembroInferiorDer.value
                        && !f.pieDer.value && !f.miembroInferiorIzq.value}"
                      formControlName="manoDer" inputId="manoDer" label="Mano derecha" name="manoDer"
                      [ngModel]="examen.manoDer" [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </div>
                  <div class="p-field-checkbox">
                    <p-checkbox binary="true" [ngClass]="{'ng-invalid ng-dirty': submitted && f.osteoarticularAlteraciones.value && !f.miembroSuperiorIzq.value
                        && !f.miembroSuperiorDer.value && !f.manoDer.value && !f.manoIzq.value && !f.dedosManoDerecha.value && !f.dedosManoIzquierda.value
                        && !f.rodillaIzq.value && !f.rodillaDer.value && !f.pieIzq.value && !f.miembroInferiorDer.value
                        && !f.pieDer.value && !f.miembroInferiorIzq.value}"
                      formControlName="miembroInferiorDer" inputId="miembroInferiorDer" label="Miembro I. derecho" name="miembroInferiorDer"
                      [ngModel]="examen.miembroInferiorDer" [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </div>
                  <div class="p-field-checkbox">
                    <p-checkbox binary="true" [ngModel]="examen.pieDer" [disabled]="examen?.modoVista === 'ver'"
                      [ngClass]="{'ng-invalid ng-dirty': submitted && f.osteoarticularAlteraciones.value && !f.miembroSuperiorIzq.value
                        && !f.miembroSuperiorDer.value && !f.manoDer.value && !f.manoIzq.value && !f.dedosManoDerecha.value && !f.dedosManoIzquierda.value
                        && !f.rodillaIzq.value && !f.rodillaDer.value && !f.pieIzq.value && !f.miembroInferiorDer.value
                        && !f.pieDer.value && !f.miembroInferiorIzq.value}"
                      formControlName="pieDer" inputId="pieDer" label="Pie derecho" name="pieDer">
                    </p-checkbox>
                  </div>
                </div>
                <div class="p-md-3">
                  <div class="p-field-checkbox">
                    <p-checkbox binary="true" [ngClass]="{'ng-invalid ng-dirty': submitted && f.osteoarticularAlteraciones.value && !f.miembroSuperiorIzq.value
                        && !f.miembroSuperiorDer.value && !f.manoDer.value && !f.manoIzq.value && !f.dedosManoDerecha.value && !f.dedosManoIzquierda.value
                        && !f.rodillaIzq.value && !f.rodillaDer.value && !f.pieIzq.value && !f.miembroInferiorDer.value
                        && !f.pieDer.value && !f.miembroInferiorIzq.value}"
                      formControlName="manoIzq" inputId="manoIzq" label="Mano izquierda" name="manoIzq"
                      [ngModel]="examen.manoIzq" [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </div>
                  <div class="p-field-checkbox">
                    <p-checkbox binary="true" [ngClass]="{'ng-invalid ng-dirty': submitted && f.osteoarticularAlteraciones.value && !f.miembroSuperiorIzq.value
                        && !f.miembroSuperiorDer.value && !f.manoDer.value && !f.manoIzq.value && !f.dedosManoDerecha.value && !f.dedosManoIzquierda.value
                        && !f.rodillaIzq.value && !f.rodillaDer.value && !f.pieIzq.value && !f.miembroInferiorDer.value
                        && !f.pieDer.value && !f.miembroInferiorIzq.value}"
                      formControlName="miembroInferiorIzq" inputId="miembroInferiorIzq" label="Miembro I. izquierdo" name="miembroInferiorIzq"
                      [ngModel]="examen.miembroInferiorIzq" [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </div>
                  <div class="p-field-checkbox">
                    <p-checkbox binary="true" [ngClass]="{'ng-invalid ng-dirty': submitted && f.osteoarticularAlteraciones.value && !f.miembroSuperiorIzq.value
                        && !f.miembroSuperiorDer.value && !f.manoDer.value && !f.manoIzq.value && !f.dedosManoDerecha.value && !f.dedosManoIzquierda.value
                        && !f.rodillaIzq.value && !f.rodillaDer.value && !f.pieIzq.value && !f.miembroInferiorDer.value
                        && !f.pieDer.value && !f.miembroInferiorIzq.value}"
                      formControlName="pieIzq" inputId="pieIzq" label="Pie izquierdo" name="pieIzq"
                      [ngModel]="examen.pieIzq" [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </div>
                </div>
              </div>
              <app-invalid-from-message *ngIf="submitted && f.osteoarticularAlteraciones.value && !f.miembroSuperiorIzq.value && !f.miembroSuperiorDer.value
                && !f.manoDer.value && !f.manoIzq.value && !f.dedosManoDerecha.value && !f.dedosManoIzquierda.value && !f.rodillaIzq.value
                && !f.rodillaDer.value && !f.pieIzq.value && !f.miembroInferiorDer.value && !f.pieDer.value && !f.miembroInferiorIzq.value">
              </app-invalid-from-message>
            </div>
            <div class="p-col-12 p-md-6 print_row-full print_dont_break">
              <app-fiel-title label="Observaciones"></app-fiel-title>
              <p [ngClass]="{'print_show-on-print': f.observacionesOsteoarticular.value.length > 0,
                'print_hide-on-print': f.observacionesOsteoarticular.value.length < 1}"
                class="print_hidden-area-before-print print_row-full p-field-word-break">
                {{f.observacionesOsteoarticular.value}}
              </p>
              <textarea class="print_hide-on-print"
                [ngClass]="{'ng-invalid ng-dirty': submitted && f.observacionesOsteoarticular.invalid}" cols="30"
                formControlName="observacionesOsteoarticular" id="result" maxlength="1000" name="resul"
                pInputTextarea rows="5" [attr.disabled]="examen?.modoVista === 'ver' ? true : null">
              </textarea>
              <small style="text-align: end;">
                {{ f.observacionesOsteoarticular.value.length }}/1000
              </small>
              <app-invalid-from-message *ngIf="submitted && f.observacionesOsteoarticular.errors?.required">
              </app-invalid-from-message>
              <app-invalid-from-message *ngIf="f.observacionesOsteoarticular.errors?.maxlength"
                message="Solo se permiten {{ f.observacionesOsteoarticular.errors.maxlength.requiredLength  }} caracteres">
              </app-invalid-from-message>
            </div>
          </div>
          <!--NEUROLOGICO-->
          <div *ngIf="configForm.findSection('Neurologico')" class="p-col-12 p-md-12">
            <p-divider></p-divider>
            <div class="p-col-12 p-md-12 print_dont_break">
              <app-fiel-title label="Estudio neurológico con alteraciones" required="true"></app-fiel-title>
              <div style="display: flex; flex-direction: row; white-space: nowrap" [ngClass]="{'ng-invalid ng-dirty': submitted && f.examenNeurologicoAlteraciones.invalid }">
                <p-radioButton name="examenNeurologicoAlteraciones" [value]="true" formControlName="examenNeurologicoAlteraciones"
                  label="Si" [ngClass]="{'ng-invalid ng-dirty': submitted && f.examenNeurologicoAlteraciones.invalid}"
                  [disabled]="examen?.modoVista === 'ver'" (onClick)="clickRadioButton('SI', 'NEUROLOGICO')">
                </p-radioButton>
                <p-radioButton name="examenNeurologicoAlteraciones" [value]="false" formControlName="examenNeurologicoAlteraciones"
                  label="Se examinó y no presentó alteraciones" [ngClass]="{'ng-invalid ng-dirty': submitted && f.examenNeurologicoAlteraciones.invalid}"
                  [disabled]="examen?.modoVista === 'ver'" (onClick)="clickRadioButton('NO', 'NEUROLOGICO')">
                </p-radioButton>
              </div>
              <app-invalid-from-message *ngIf="submitted && f.examenNeurologicoAlteraciones.invalid"></app-invalid-from-message>
            </div>
            <div class="p-col-12 p-md-8 print_dont_break">
              <app-fiel-title label="Alteraciones"></app-fiel-title>
              <div style="display: flex;">
                <div class="p-md-3">
                  <div class="p-field-checkbox">
                    <p-checkbox binary="true" [ngClass]="{'ng-invalid ng-dirty': submitted && f.examenNeurologicoAlteraciones.value
                      && !f.rombergAnormal.value && !f.coordinacion.value && !f.marcha.value && !f.temblor.value && !f.sensibilidad.value
                      && !f.reflejos.value && !f.pruebaDedoNariz.value && !f.alteracionImportanteSentidoOlfato.value}"
                      formControlName="rombergAnormal" inputId="rombergAnormal" label="Romberg anormal" name="rombergAnormal"
                      [ngModel]="examen.rombergAnormal" [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </div>
                  <div class="p-field-checkbox">
                    <p-checkbox binary="true" [ngClass]="{'ng-invalid ng-dirty': submitted && f.examenNeurologicoAlteraciones.value
                      && !f.rombergAnormal.value && !f.coordinacion.value && !f.marcha.value && !f.temblor.value && !f.sensibilidad.value
                      && !f.reflejos.value && !f.pruebaDedoNariz.value && !f.alteracionImportanteSentidoOlfato.value}"
                      formControlName="coordinacion" inputId="coordinacion" label="Coordinación" name="coordinacion"
                      [ngModel]="examen.coordinacion" [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </div>
                </div>
                <div class="p-md-3">
                  <div class="p-field-checkbox">
                    <p-checkbox binary="true" [ngClass]="{'ng-invalid ng-dirty': submitted && f.examenNeurologicoAlteraciones.value
                      && !f.rombergAnormal.value && !f.coordinacion.value && !f.marcha.value && !f.temblor.value && !f.sensibilidad.value
                      && !f.reflejos.value && !f.pruebaDedoNariz.value && !f.alteracionImportanteSentidoOlfato.value}"
                      formControlName="marcha" inputId="marcha" label="Marcha" name="marcha"
                      [ngModel]="examen.marcha" [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </div>
                  <div class="p-field-checkbox">
                    <p-checkbox binary="true" [ngClass]="{'ng-invalid ng-dirty': submitted && f.examenNeurologicoAlteraciones.value
                      && !f.rombergAnormal.value && !f.coordinacion.value && !f.marcha.value && !f.temblor.value && !f.sensibilidad.value
                      && !f.reflejos.value && !f.pruebaDedoNariz.value && !f.alteracionImportanteSentidoOlfato.value}"
                      formControlName="temblor" inputId="temblor" label="Temblor" name="temblor"
                      [ngModel]="examen.temblor" [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </div>
                </div>
                <div class="p-md-3">
                  <div class="p-field-checkbox">
                    <p-checkbox binary="true" [ngClass]="{'ng-invalid ng-dirty': submitted && f.examenNeurologicoAlteraciones.value
                      && !f.rombergAnormal.value && !f.coordinacion.value && !f.marcha.value && !f.temblor.value && !f.sensibilidad.value
                      && !f.reflejos.value && !f.pruebaDedoNariz.value && !f.alteracionImportanteSentidoOlfato.value}"
                      formControlName="sensibilidad" inputId="sensibilidad" label="Sensibilidad" name="sensibilidad"
                      [ngModel]="examen.sensibilidad" [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </div>
                  <div class="p-field-checkbox">
                    <p-checkbox binary="true" [ngClass]="{'ng-invalid ng-dirty': submitted && f.examenNeurologicoAlteraciones.value
                        && !f.rombergAnormal.value && !f.coordinacion.value && !f.marcha.value && !f.temblor.value && !f.sensibilidad.value
                        && !f.reflejos.value && !f.pruebaDedoNariz.value && !f.alteracionImportanteSentidoOlfato.value}"
                      formControlName="pruebaDedoNariz" inputId="pruebaDedoNariz" label="Prueba dedo-nariz" name="pruebaDedoNariz"
                      [ngModel]="examen.pruebaDedoNariz" [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </div>
                </div>
                <div class="p-md-3">
                  <div class="p-field-checkbox">
                    <p-checkbox binary="true" [ngClass]="{'ng-invalid ng-dirty': submitted && f.examenNeurologicoAlteraciones.value
                        && !f.rombergAnormal.value && !f.coordinacion.value && !f.marcha.value && !f.temblor.value && !f.sensibilidad.value
                        && !f.reflejos.value && !f.pruebaDedoNariz.value && !f.alteracionImportanteSentidoOlfato.value}"
                      formControlName="reflejos" inputId="reflejos" label="Reflejos" name="reflejos"
                      [ngModel]="examen.reflejos" [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </div>
                  <div class="p-field-checkbox">
                    <p-checkbox binary="true" [ngClass]="{'ng-invalid ng-dirty': submitted && f.examenNeurologicoAlteraciones.value
                        && !f.rombergAnormal.value && !f.coordinacion.value && !f.marcha.value && !f.temblor.value && !f.sensibilidad.value
                        && !f.reflejos.value && !f.pruebaDedoNariz.value && !f.alteracionImportanteSentidoOlfato.value}"
                      formControlName="alteracionImportanteSentidoOlfato" inputId="alteracionImportanteSentidoOlfato"
                      label="Alt. importante del sentido del olfato" name="alteracionImportanteSentidoOlfato"
                      [ngModel]="examen.alteracionImportanteSentidoOlfato" [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </div>
                </div>
              </div>
              <app-invalid-from-message *ngIf="submitted && f.examenNeurologicoAlteraciones.value && !f.rombergAnormal.value
                && !f.coordinacion.value && !f.marcha.value && !f.temblor.value && !f.sensibilidad.value
                && !f.reflejos.value && !f.pruebaDedoNariz.value && !f.alteracionImportanteSentidoOlfato.value">
              </app-invalid-from-message>
            </div>
            <div class="p-col-12 p-md-6 print_row-full print_dont_break">
              <app-fiel-title label="Observaciones"></app-fiel-title>
              <p [ngClass]="{'print_show-on-print': f.observacionesNeurologico.value.length > 0,
                'print_hide-on-print': f.observacionesNeurologico.value.length < 1}"
                class="print_hidden-area-before-print print_row-full p-field-word-break">
                {{f.observacionesNeurologico.value}}
              </p>
              <textarea class="print_hide-on-print"
                [ngClass]="{'ng-invalid ng-dirty': submitted && f.observacionesNeurologico.invalid}" cols="30"
                formControlName="observacionesNeurologico" id="result" maxlength="1000" name="resul"
                pInputTextarea rows="5" [attr.disabled]="examen?.modoVista === 'ver' ? true : null">
              </textarea>
              <small style="text-align: end;">
                {{ f.observacionesNeurologico.value.length }}/1000
              </small>
              <app-invalid-from-message *ngIf="submitted && f.observacionesNeurologico.errors?.required">
              </app-invalid-from-message>
              <app-invalid-from-message *ngIf="f.observacionesNeurologico.errors?.maxlength"
                message="Solo se permiten {{ f.observacionesNeurologico.errors.maxlength.requiredLength  }} caracteres">
              </app-invalid-from-message>
            </div>
          </div>
          <div class="p-grid print_dont_break" style="justify-content: center; text-align: justify;">
            <div class="p-col-12 p-md-6">
              <p>
                Tomo conocimiento de los hallazgos del estudio que me han realizado y, así mismo, se me informa que estos no configuran
                un estudio general de salud sino que solo tienen por objetivo detectar afecciones de origen profesional o entidad de la
                exposición o riesgos específicos de trabajo. Autorizo la entrega de información al servicio médico o profesional médico
                de la empresa empleadora ante requerimiento de estos últimos, de toda información relativa a los estudios periódicos
                que se me han realizado. Se me informan las patologías inculpables para las cuales debo concurrir al médico personal o
                mi obra social.
              </p>
            </div>
          </div>
        </div>
      </div>

      <!--Seccion Dictamen medico-->
      <div class="print_hide-on-print" *ngIf="configForm.findSection('Dictamen medico')">
        <div class="p-grid p-mt-2">
          <span class="p-title-seccion">
            {{ configForm.findNumberSection("Dictamen medico") }}.Dictamen médico
          </span>
        </div>
        <p-divider></p-divider>

        <div class="p-grid">
          <!--Campo Tipo Dictamen-->
          <div *ngIf="configForm.findField('codigoDictamen')" class="p-field p-col-12 p-md-6">
            <app-fiel-title label="Tipo de dictamen" required="true"></app-fiel-title>
            <div style="display: flex; flex-direction: row;"
              [ngClass]="{'ng-invalid ng-dirty': submitted && f.codigoDictamen.invalid }">

              <div *ngFor="let item of tiposDictamen" class="p-field-checkbox">

                <p-radioButton name="codigoDictamen" [value]="item.codigo" formControlName="codigoDictamen"
                  label="{{ item.descripcion }}"
                  [ngClass]="{'ng-invalid ng-dirty': submitted && f.codigoDictamen.invalid}"
                  [disabled]="examen?.modoVista === 'ver'" [(ngModel)]="examen.codigoDictamen">
                </p-radioButton>

              </div>
            </div>
            <app-invalid-from-message *ngIf="submitted && f.codigoDictamen.invalid"></app-invalid-from-message>
          </div>

          <!--Campo Especialidades-->
          <div class="p-field p-col-12 p-md-6">
            <app-fiel-title label="Especialidad" required="true"></app-fiel-title>
            <p-dropdown [ngClass]="{'ng-invalid ng-dirty': submitted && f.medicoEspecialidad.invalid}"
              [options]="especialidades" formControlName="medicoEspecialidad" placeholder="Seleccione"
              optionLabel="descripcion" optionValue="codigo" [showClear]="true"
              [disabled]="examen?.modoVista === 'ver'">
            </p-dropdown>
            <app-invalid-from-message *ngIf="submitted && f.medicoEspecialidad.invalid"></app-invalid-from-message>
          </div>

          <!--Campo Médico-->
          <div *ngIf="configForm.findField('medicoNombre')" class="p-field p-col-12 p-md-6">
            <app-fiel-title label="Médico" required="true"></app-fiel-title>
            <input [ngClass]="{'ng-invalid ng-dirty': submitted && f.medicoNombre.invalid}" alfanumericoDirective
              formControlName="medicoNombre" id="medico" name="medico" maxlength="100" pInputText type="text"
              [attr.disabled]="examen?.modoVista === 'ver' ? true : null" />
            <app-invalid-from-message *ngIf="submitted && f.medicoNombre.invalid"></app-invalid-from-message>
          </div>

          <!--Campo Matricula-->
          <div class="p-field p-col-12 p-md-6">
            <app-fiel-title label="Matrícula" required="true"></app-fiel-title>
            <!-- Modificar para validar el formato de la matricula -->
            <input [ngClass]="{'ng-invalid ng-dirty': submitted && f.matricula.invalid}" numberDirective
              formControlName="matricula" id="matricula" name="matricula" maxlength="18" pInputText type="text"
              [attr.disabled]="examen?.modoVista === 'ver' ? true : null" />
            <app-invalid-from-message *ngIf="submitted && f.matricula.invalid"></app-invalid-from-message>
          </div>
        </div>
        <div class="p-grid p-form-footer">
					<div class="p-field p-col-12 p-md-12" style="justify-content: flex-start; display: flex;">
						<button [disabled]="examen?.modoVista === 'ver' ? true : null" pButton pRipple type="button" label="Firmar" (click)="showModalFirma()"></button>
					</div>
          <div class="p-field p-col-12 p-md-12">
            <app-invalid-from-message *ngIf="submitted && medicoFirmaB64 == null" message="Por favor firmar el estudio"></app-invalid-from-message>
          </div>
				</div>
      </div>

      <!-- ------------ ADJUNTAR ARCHIVO ------------ -->
      <div *ngIf="configForm.findSection('Adjuntos')" class="p-grid-space print_hide-on-print">
        <label class="p-title-seccion">
          {{ configForm.findNumberSection("Adjuntos") }}.Archivos adjuntos
          <strong *ngIf="attachedFiles.attachedFilesValidQuantity >= 1">:</strong>
          <span style="font-weight: normal;" *ngIf="attachedFiles.data.length >= 1">
            {{ attachedFiles.attachedFilesValidQuantity }}
          </span>
        </label>
        <p-divider></p-divider>

        <app-attach-upload-file [examenNumero]="this.examen?.id"
          [isRequire]="configForm.isAttachedFileRequire" (filesAttachedData)="getAttachedFiles($event)"
          [attachedFilesFromBackend]="this.examen?.attachments" [viewMode]="this.examen?.modoVista"
          [esAunPorEnviar]="this.examen?.aunPorEnviar || false">
        </app-attach-upload-file>

        <app-attached-file-mandatory-message
          *ngIf=" submitted &&  configForm.isAttachedFileRequire && attachedFiles.isEmpty  ">
        </app-attached-file-mandatory-message>
      </div>
      <!-- ------------------------------------------------footer botones------------------------------------------------ -->
      <div class="p-grid p-form-footer">
        <div class="p-col-12 p-md-12" style="justify-content: flex-end; display: flex;">
          <ng-container *ngIf="examen?.modoVista === 'ver'">
            <button pButton pRipple type="button" label="Volver" class="p-button-text" (click)="goBack()"></button>
          </ng-container>

          <ng-container *ngIf="examen?.modoVista !== 'ver'">
            <button pButton pRipple type="button" label="Cancelar" class="p-button-text" (click)="goBack()"></button>
            <p-button type="submit" label="Guardar" *ngIf="!enviandose"
              [disabled]="examen?.modoVista === 'edit' && !isOnline && !examen?.aunPorEnviar">
            </p-button>
            <p-button type="submit" label="Enviando..." *ngIf="enviandose" disabled="true"></p-button>
          </ng-container>
        </div>
      </div>

      <app-print-footer [firmaB64]="examen?.firmaB64"
                        [medicoFirmaB64]="medicoFirmaB64"
                        [trabajadorApellidoNombre]="f.apellidoNombre.value"
                        [medicoNombre]="f.medicoNombre?.value"
                        [medicoEspecialidad]="f.medicoEspecialidad.value"
                        [medicoMatricula]="f.matricula?.value">
      </app-print-footer>
    </div>
  </form>

  <p-confirmDialog #cd [closable]="false" [style]="{ width: '500px' }" key="goBackForm" styleClass="p-dialog-custom">
    <p-footer>
      <button (click)="cd.reject()" class="p-button-text" label="No, volver al examen" pButton type="button"></button>
      <button (click)="cd.accept()" label="Si, cancelar carga" pButton type="button"></button>
    </p-footer>

  </p-confirmDialog>
</main>

<section id="modal-firma">
	<app-topaz (datosFirma)="recibirDatosFirma($event)" [displayModalFirma]="displayModalFirma" (closeModal)="closeModalFirma()"></app-topaz>
</section>
